export const transactionsTranslations: Record<string, any> = {
  "pt": {
    title: "Transações",
    description: "Fonte da verdade para toda a atividade financeira",
    empty_state_title: "Ainda não existem transações",
    empty_state_description: "Liga a tua conta bancária via Open Banking para importar e visualizar automaticamente todas as tuas transações aqui.",
    empty_state_button: "Conectar banco",
    vendor_label: "Fornecedor",
    vendor_create: "Criar fornecedor",
    vendor_update: "Alterar fornecedor",
    vendor_created: "Fornecedor criado",
    vendor_create_failed: "Falha ao criar fornecedor",
    vendor_name_required: "O nome do fornecedor é obrigatório",
    vendor_name_placeholder: "Nome do fornecedor",
    vendor_updated: "Fornecedor atualizado",
    vendor_assigned: "Fornecedor associado",
    vendor_clear: "Sem fornecedor",
    vendor_removed: "Fornecedor desassociado",
    vendor_remove_failed: "Falha ao desassociar fornecedor",
    vendor_select_placeholder: "Selecionar fornecedor",
    vendor_select_empty: "Sem fornecedores disponíveis",

    person_label: "Associated person",
    person_select_placeholder: "Select person",
    person_select_empty: "No active people",
    person_assigned: "Person associated",
    person_removed: "Person unassigned",
    person_update_failed: "Failed to update person",
    person_remove_failed: "Failed to unassign person",
    person_clear: "No person",
    person_missing_context: "Missing context",
    allocation_title: "Alocação",
    allocation_description: "Distribui esta transação por pessoas para análise (não altera o movimento bancário).",
    allocation_loading: "A carregar alocações...",
    allocation_empty: "Sem alocações.",
    allocation_add: "Dividir por várias pessoas",
    allocation_edit: "Editar alocação",
    allocation_remove: "Remover alocação",
    allocation_recommended: "Recomendado",
    allocation_editor_title: "Alocar a pessoas",
    allocation_editor_description: "Distribui o valor por pessoas para análise.",
    allocation_person_placeholder: "Selecionar pessoa",
    allocation_no_people: "Sem pessoas ativas",
    allocation_amount_placeholder: "Valor",
    allocation_note_placeholder: "Nota (opcional)",
    allocation_add_row: "Adicionar pessoa",
    allocation_add_all_people: "Adicionar todas as pessoas",
    allocation_table_person: "Pessoa",
    allocation_table_amount: "Valor",
    allocation_table_note: "Nota",
    allocation_table_actions: "Ações",
    allocation_total: "Total alocado",
    allocation_remainder: "Por alocar",
    allocation_microcopy: "As alocações são apenas analíticas e não alteram a transação bancária.",
    allocation_not_balanced_hint: "O total alocado tem de coincidir com o valor da transação.",
    allocation_cancel: "Cancelar",
    allocation_save: "Guardar",
    allocation_required: "Adiciona pelo menos uma pessoa.",
    allocation_invalid_rows: "Preenche pessoa e valor em todas as linhas.",
    allocation_duplicate_person: "Cada pessoa só pode ser alocada uma vez.",
    allocation_not_balanced: "O total alocado deve ser {{amount}}.",
    allocation_saved: "Alocação guardada",
    allocation_save_failed: "Falha ao guardar a alocação",
    allocation_load_failed: "Falha ao carregar alocações",
    allocation_removed: "Alocação removida",
    allocation_remove_failed: "Falha ao remover a alocação",
    allocation_remove_title: "Remover alocação?",
    allocation_remove_description: "A alocação desta transação será removida.",
    allocation_remove_confirm: "Remover",
    allocation_remove_cancel: "Cancelar",
    client_label: "Cliente",
    client_create: "Criar cliente",
    client_update: "Alterar cliente",
    client_created: "Cliente criado",
    client_create_failed: "Falha ao criar cliente",
    client_name_required: "O nome do cliente é obrigatório",
    client_name_placeholder: "Nome do cliente",
    client_updated: "Cliente atualizado",
    client_assigned: "Cliente associado",
    client_clear: "Sem cliente",
    client_removed: "Cliente desassociado",
    client_remove_failed: "Falha ao desassociar cliente",
    client_select_placeholder: "Selecionar cliente",
    client_select_empty: "Sem clientes disponíveis",
    project_label: "Projeto",
    project_select_placeholder: "Selecionar projeto",
    project_select_empty: "Sem projetos disponíveis",
    project_select_loading: "A carregar projetos...",
    project_select_requires_client: "Selecione primeiro um cliente",
    project_assigned: "Projeto associado",
    project_updated: "Projeto atualizado",
    project_update_failed: "Falha ao atualizar o projeto",
    project_clear: "Sem projeto",
    project_removed: "Projeto desassociado",
    project_remove_failed: "Falha ao desassociar o projeto",
    category_create: "Criar categoria",
    category_created: "Categoria criada",
    category_create_failed: "Falha ao criar a categoria",
    category_name_required: "O nome da categoria é obrigatório",
    category_name_placeholder: "Nome da categoria",
    category_update_failed: "Falha ao atualizar a categoria",
    document_requirement_update_failed: "Falha ao atualizar o requisito de documento",
    document_upload_failed: "Falha ao enviar o documento",
    document_upload_success: "Documento enviado",
    document_upload_too_large: "O documento deve ter até 10MB",
    document_download: "Descarregar documento",
    document_download_failed: "Falha ao descarregar o documento",
    document_delete: "Eliminar documento",
    document_delete_failed: "Falha ao eliminar o documento",
    document_delete_title: "Eliminar documento?",
    document_delete_description: "O documento \"{{name}}\" será eliminado permanentemente.",
    document_delete_confirm: "Eliminar",
    document_delete_cancel: "Cancelar",
    document_request_action: "Pedir documentação",
    document_request_action_person: "Pedir a {{name}} o documento referente a esta transação",
    document_request_status: "Documentação já pedida",
    document_request_status_person: "Documentação já pedida a {{name}}",
    document_request_sent: "Pedido enviado em {{date}}",
    document_request_missing_email: "Adiciona o email da pessoa para pedir documentação.",
    document_request_email_label: "Email da pessoa",
    document_request_email_placeholder: "email@empresa.com",
    document_request_email_save_and_send: "Guardar e pedir",
    document_request_email_invalid: "Email inválido.",
    document_request_email_save_failed: "Falha ao guardar o email.",
    document_request_send_success: "Pedido enviado.",
    document_request_send_failed: "Falha ao enviar o pedido.",
    comments_title: "Comentários",
    comments_loading: "A carregar comentários...",
    comments_empty: "Ainda não existem comentários.",
    comments_placeholder: "Escreva um comentário...",
    comments_send: "Enviar",
    comments_private_label: "Privado",
    comments_private_badge: "Privado",
    comments_deleted_placeholder: "Comentário removido",
    comments_edited_label: "editado",
    comments_attachment_add: "Anexar",
    comments_attachment_too_large: "Os anexos devem ter até 10MB",
    comments_attachment_upload_failed: "Falha ao enviar anexo",
    comments_attachment_delete_failed: "Falha ao eliminar anexo",
    comments_create_failed: "Falha ao criar comentário",
    comments_update_failed: "Falha ao atualizar comentário",
    comments_delete_failed: "Falha ao eliminar comentário",
    comments_delete_confirm: "Eliminar este comentário?",
    comments_author_fallback: "Utilizador",
    comments_uploading: "A enviar...",
    comments_load_error: "Falha ao carregar comentários.",
    logo_feedback_label: "Feedback do logo",
    logo_feedback_up: "Logo correto",
    logo_feedback_down: "Logo incorreto",
    logo_feedback_saved: "Obrigado pelo feedback do logo.",
    logo_feedback_removed: "Logo removido para esta organização.",
    logo_feedback_failed: "Não foi possível guardar o feedback do logo.",
    bulk_selected: "Selecionadas: {{count}}",
    bulk_all_selected: "Todas as {{count}} transações selecionadas",
    bulk_select_all: "Selecionar todas as {{count}} transações",
    bulk_clear: "Limpar seleção",
    bulk_no_document: "Marcar como completa sem documento",
    bulk_no_document_title: "Marcar como completa sem documento?",
    bulk_no_document_description: "Tem a certeza que pretende marcar {{count}} transações como completas sem documento?",
    bulk_no_document_confirm: "Marcar como completa",
    bulk_no_document_cancel: "Cancelar",
    bulk_actions_title: "Ações em massa",
    bulk_vendor_confirm_title: "Atribuir fornecedor?",
    bulk_vendor_confirm_description: "Tem a certeza que pretende atribuir o fornecedor \"{{name}}\" a {{count}} transações?",
    bulk_vendor_confirm_confirm: "Atribuir fornecedor",
    bulk_vendor_confirm_cancel: "Cancelar",
    bulk_client_confirm_title: "Atribuir cliente?",
    bulk_client_confirm_description: "Tem a certeza que pretende atribuir o cliente \"{{name}}\" a {{count}} transações?",
    bulk_client_confirm_confirm: "Atribuir cliente",
    bulk_client_confirm_cancel: "Cancelar",
    bulk_project_confirm_title: "Atribuir projeto?",
    bulk_project_confirm_description: "Tem a certeza que pretende atribuir o projeto \"{{name}}\" a {{count}} transações?",
    bulk_project_confirm_confirm: "Atribuir projeto",
    bulk_project_confirm_cancel: "Cancelar",
    bulk_category_confirm_title: "Atribuir categoria?",
    bulk_category_confirm_description: "Tem a certeza que pretende atribuir a categoria \"{{name}}\" a {{count}} transações?",
    bulk_category_confirm_confirm: "Atribuir categoria",
    bulk_category_confirm_cancel: "Cancelar",
    bulk_assign_vendor: "Atribuir fornecedor",
    bulk_assign_client: "Atribuir cliente",
    bulk_assign_project: "Atribuir projeto",
    bulk_assign_category: "Atribuir categoria",
    search_placeholder: "Pesquisar transações...",
    filter_category_placeholder: "Categoria",
    filter_category_all: "Todas as categorias",
    filter_status_placeholder: "Estado",
    filter_status_all: "Todos os estados",
    filter_type_placeholder: "Tipo",
    filter_type_all: "Todas",
    filter_type_income: "Receitas",
    filter_type_expense: "Despesas",
    filter_project_placeholder: "Projeto",
    filter_project_all: "Todos os projetos",
    filter_project_empty: "Sem projetos",
    filter_amount_label: "Valor",
    filter_amount_min: "Valor mínimo",
    filter_amount_max: "Valor máximo",
    filters_advanced: "Filtros avançados",
    filters_apply: "Aplicar",
    filters_clear_all: "Limpar filtros",
    recover_logos: "Recuperar logos",
    recover_logos_success: "Logos recuperados: {{resolved}} ({{reused}} em cache)",
    recover_logos_failed: "Falha ao recuperar logos",
    reprocess_merchants: "Reprocessar comerciantes",
    reprocess_merchants_success: "Comerciantes reprocessados: {{updated}}/{{evaluated}} ({{hints}} hints)",
    reprocess_merchants_failed: "Falha ao reprocessar comerciantes",
    filters_remove_chip: "Remover filtro {{label}}",
    filters_chip_search: "Pesquisa",
    filters_chip_date: "Data",
    filters_chip_account: "Conta",
    filters_chip_category: "Categoria",
    filters_chip_status: "Estado",
    filters_chip_project: "Projeto",
    filters_chip_type: "Tipo",
    filters_chip_amount: "Valor",
    filter_account_placeholder: "Conta",
    filter_account_all: "Todas as contas",
    filter_account_manage: "Gerir contas",
    filter_categories: "Categorias",
    filter_accounts: "Contas",
    filter_all_short: "Todas",
    filter_n_selected: "{{count}} selecionada",
    filter_missing_info: "Info em falta",
    filter_missing_info_tooltip: "Mostrar apenas transações com informação em falta",
    filter_date_from: "Data inicial",
    filter_date_to: "Data final",
    table_operation: "Operação",
    table_date: "Data",
    table_status: "Estado",
    table_category: "Categoria",
    table_bank: "Banco",
    table_amount: "Valor",
    loading: "A carregar transações...",
    empty_table: "Nenhuma transação encontrada.",
    status_complete: "Completa",
    status_missing_info: "Info em falta",
    status_missing_info_hint: "Esta transação requer informação ou documentos adicionais",
    status_document_requested: "Documentação pedida",
    status_document_requested_hint: "Foi pedido um documento para esta transação.",
    showing_count: "A mostrar {{shown}} de {{total}} transações",
    loading_more: "A carregar...",
    load_previous: "Carregar transações anteriores",
    details_sr_title: "Detalhes e informação da transação",
    details_title: "Detalhes",
    details_date_label: "Data",
    details_description_label: "Descrição",
    details_status_label: "Estado",
    details_status_complete: "Completa",
    details_status_missing: "Informação em falta",
    details_reference_label: "Referência",
    details_category_label: "Categoria",
    details_accounting_label: "Contabilidade",
    details_account_label: "Conta",
    details_notes_label: "Notas",
    documents_title_missing: "Informação em falta",
    documents_title: "Documentos",
    documents_missing_description: "Adicione um documento para completar esta transação",
    documents_description: "Carregue faturas ou recibos para esta transação",
    documents_uploading: "A carregar...",
    documents_add: "Adicionar documento",
    documents_upload_progress: "A carregar {{current}}/{{total}}",
    documents_drop: "Largue o ficheiro para carregar",
    documents_drag: "Arraste e largue ficheiros aqui",
    documents_failed_title: "Falhas no carregamento",
    documents_no_required_label: "Documento não obrigatório",
    documents_no_required_hint: "Marcar como não requerendo documentação",
    documents_preview_label: "Pré-visualizar documentos ({{count}})",
    documents_preview_title: "Pré-visualização de documentos",
    documents_preview_open: "Abrir",
    documents_preview_empty: "Sem documentos disponíveis",
    documents_preview_hint: "A pré-visualização é apenas leitura e não altera a transação.",
    documents_preview_zoom_in: "Aumentar zoom",
    documents_preview_zoom_out: "Diminuir zoom",
    documents_preview_zoom_fit: "Ajustar",
    change_category: "Alterar categoria",
    select_all_label: "Selecionar todas as transações",
    select_one_label: "Selecionar transação",
    default_description: "Transação bancária",
    default_account: "Conta bancária",
    default_document_name: "Documento",
    load_error: "Falha ao carregar transações."
  },
  "en": {
    title: "Transactions",
    description: "Source of truth for all financial activity",
    empty_state_title: "No transactions yet",
    empty_state_description: "Connect your bank account via Open Banking to automatically import and view all your transactions here.",
    empty_state_button: "Connect bank account",
    vendor_label: "Vendor",
    vendor_create: "Create vendor",
    vendor_update: "Change vendor",
    vendor_created: "Vendor created",
    vendor_create_failed: "Failed to create vendor",
    vendor_name_required: "Vendor name is required",
    vendor_name_placeholder: "Vendor name",
    vendor_updated: "Vendor updated",
    vendor_assigned: "Vendor assigned",
    vendor_clear: "No vendor",
    vendor_removed: "Vendor unassigned",
    vendor_remove_failed: "Failed to unassign vendor",
    vendor_select_placeholder: "Select vendor",
    vendor_select_empty: "No vendors available",

    person_label: "Associated person",
    person_select_placeholder: "Select person",
    person_select_empty: "No active people",
    person_assigned: "Person associated",
    person_removed: "Person unassigned",
    person_update_failed: "Failed to update person",
    person_remove_failed: "Failed to unassign person",
    person_clear: "No person",
    person_missing_context: "Missing context",
    allocation_title: "Allocation",
    allocation_description: "Distribute this transaction across people for analytics (does not change the bank movement).",
    allocation_loading: "Loading allocations...",
    allocation_empty: "No allocations yet.",
    allocation_add: "Allocate to people",
    allocation_edit: "Edit allocation",
    allocation_remove: "Remove allocation",
    allocation_recommended: "Recommended",
    allocation_editor_title: "Allocate to people",
    allocation_editor_description: "Split the amount across people for analytics.",
    allocation_person_placeholder: "Select person",
    allocation_no_people: "No active people",
    allocation_amount_placeholder: "Amount",
    allocation_note_placeholder: "Note (optional)",
    allocation_add_row: "Add person",
    allocation_add_all_people: "Add all people",
    allocation_table_person: "Person",
    allocation_table_amount: "Amount",
    allocation_table_note: "Note",
    allocation_table_actions: "Actions",
    allocation_total: "Allocated total",
    allocation_remainder: "Remaining",
    allocation_microcopy: "Allocations are analytics-only and do not change the bank transaction.",
    allocation_not_balanced_hint: "Allocated total must match the transaction amount.",
    allocation_cancel: "Cancel",
    allocation_save: "Save",
    allocation_required: "Add at least one person.",
    allocation_invalid_rows: "Fill in person and amount for every row.",
    allocation_duplicate_person: "Each person can only be allocated once.",
    allocation_not_balanced: "Allocated total must be {{amount}}.",
    allocation_saved: "Allocation saved",
    allocation_save_failed: "Failed to save allocation",
    allocation_load_failed: "Failed to load allocations",
    allocation_removed: "Allocation removed",
    allocation_remove_failed: "Failed to remove allocation",
    allocation_remove_title: "Remove allocation?",
    allocation_remove_description: "This transaction allocation will be removed.",
    allocation_remove_confirm: "Remove",
    allocation_remove_cancel: "Cancel",
    client_label: "Client",
    client_create: "Create client",
    client_update: "Change client",
    client_created: "Client created",
    client_create_failed: "Failed to create client",
    client_name_required: "Client name is required",
    client_name_placeholder: "Client name",
    client_updated: "Client updated",
    client_assigned: "Client assigned",
    client_clear: "No client",
    client_removed: "Client unassigned",
    client_remove_failed: "Failed to unassign client",
    client_select_placeholder: "Select client",
    client_select_empty: "No clients available",
    project_label: "Project",
    project_select_placeholder: "Select project",
    project_select_empty: "No projects available",
    project_select_loading: "Loading projects...",
    project_select_requires_client: "Select a client first",
    project_assigned: "Project assigned",
    project_updated: "Project updated",
    project_update_failed: "Failed to update project",
    project_clear: "No project",
    project_removed: "Project unassigned",
    project_remove_failed: "Failed to unassign project",
    category_create: "Create category",
    category_created: "Category created",
    category_create_failed: "Failed to create category",
    category_name_required: "Category name is required",
    category_name_placeholder: "Category name",
    category_update_failed: "Failed to update category",
    document_requirement_update_failed: "Failed to update document requirement",
    document_upload_failed: "Failed to upload document",
    document_upload_success: "Document uploaded",
    document_upload_too_large: "Document must be 10MB or smaller",
    document_download: "Download document",
    document_download_failed: "Failed to download document",
    document_delete: "Delete document",
    document_delete_failed: "Failed to delete document",
    document_delete_title: "Delete document?",
    document_delete_description: "The document \"{{name}}\" will be permanently deleted.",
    document_delete_confirm: "Delete",
    document_delete_cancel: "Cancel",
    document_request_action: "Request document",
    document_request_action_person: "Request the document from {{name}} for this transaction",
    document_request_status: "Document already requested",
    document_request_status_person: "Document already requested from {{name}}",
    document_request_sent: "Request sent on {{date}}",
    document_request_missing_email: "Add the person's email to request documentation.",
    document_request_email_label: "Person email",
    document_request_email_placeholder: "name@company.com",
    document_request_email_save_and_send: "Save and request",
    document_request_email_invalid: "Invalid email.",
    document_request_email_save_failed: "Failed to save the email.",
    document_request_send_success: "Document request sent.",
    document_request_send_failed: "Failed to send document request.",
    comments_title: "Comments",
    comments_loading: "Loading comments...",
    comments_empty: "No comments yet.",
    comments_placeholder: "Write a comment...",
    comments_send: "Send",
    comments_private_label: "Private",
    comments_private_badge: "Private",
    comments_deleted_placeholder: "Comment removed",
    comments_edited_label: "edited",
    comments_attachment_add: "Attach",
    comments_attachment_too_large: "Attachments must be 10MB or smaller",
    comments_attachment_upload_failed: "Failed to upload attachment",
    comments_attachment_delete_failed: "Failed to delete attachment",
    comments_create_failed: "Failed to create comment",
    comments_update_failed: "Failed to update comment",
    comments_delete_failed: "Failed to delete comment",
    comments_delete_confirm: "Delete this comment?",
    comments_author_fallback: "User",
    comments_uploading: "Sending...",
    comments_load_error: "Failed to load comments.",
    logo_feedback_label: "Logo feedback",
    logo_feedback_up: "Logo looks correct",
    logo_feedback_down: "Logo is incorrect",
    logo_feedback_saved: "Thanks for the logo feedback.",
    logo_feedback_removed: "Logo removed for this organization.",
    logo_feedback_failed: "Couldn't save logo feedback.",
    bulk_selected: "Selected: {{count}}",
    bulk_all_selected: "All {{count}} transactions selected",
    bulk_select_all: "Select all {{count}} transactions",
    bulk_clear: "Clear selection",
    bulk_no_document: "Mark as complete without document",
    bulk_no_document_title: "Mark as complete without document?",
    bulk_no_document_description: "Are you sure you want to mark {{count}} transactions as complete without a document?",
    bulk_no_document_confirm: "Mark as complete",
    bulk_no_document_cancel: "Cancel",
    bulk_actions_title: "Bulk actions",
    bulk_vendor_confirm_title: "Assign vendor?",
    bulk_vendor_confirm_description: "Are you sure you want to assign vendor \"{{name}}\" to {{count}} transactions?",
    bulk_vendor_confirm_confirm: "Assign vendor",
    bulk_vendor_confirm_cancel: "Cancel",
    bulk_client_confirm_title: "Assign client?",
    bulk_client_confirm_description: "Are you sure you want to assign client \"{{name}}\" to {{count}} transactions?",
    bulk_client_confirm_confirm: "Assign client",
    bulk_client_confirm_cancel: "Cancel",
    bulk_project_confirm_title: "Assign project?",
    bulk_project_confirm_description: "Are you sure you want to assign project \"{{name}}\" to {{count}} transactions?",
    bulk_project_confirm_confirm: "Assign project",
    bulk_project_confirm_cancel: "Cancel",
    bulk_category_confirm_title: "Assign category?",
    bulk_category_confirm_description: "Are you sure you want to assign category \"{{name}}\" to {{count}} transactions?",
    bulk_category_confirm_confirm: "Assign category",
    bulk_category_confirm_cancel: "Cancel",
    bulk_assign_vendor: "Assign vendor",
    bulk_assign_client: "Assign client",
    bulk_assign_project: "Assign project",
    bulk_assign_category: "Assign category",
    search_placeholder: "Search transactions...",
    filter_category_placeholder: "Category",
    filter_category_all: "All categories",
    filter_status_placeholder: "Status",
    filter_status_all: "All statuses",
    filter_type_placeholder: "Type",
    filter_type_all: "All types",
    filter_type_income: "Income",
    filter_type_expense: "Expenses",
    filter_project_placeholder: "Project",
    filter_project_all: "All projects",
    filter_project_empty: "No projects",
    filter_amount_label: "Amount",
    filter_amount_min: "Min amount",
    filter_amount_max: "Max amount",
    filters_advanced: "Advanced filters",
    filters_apply: "Apply",
    filters_clear_all: "Clear filters",
    recover_logos: "Recover logos",
    recover_logos_success: "Logos recovered: {{resolved}} ({{reused}} cached)",
    recover_logos_failed: "Failed to recover logos",
    reprocess_merchants: "Reprocess merchants",
    reprocess_merchants_success: "Merchants reprocessed: {{updated}}/{{evaluated}} ({{hints}} hints)",
    reprocess_merchants_failed: "Failed to reprocess merchants",
    filters_remove_chip: "Remove filter {{label}}",
    filters_chip_search: "Search",
    filters_chip_date: "Date",
    filters_chip_account: "Account",
    filters_chip_category: "Category",
    filters_chip_status: "Status",
    filters_chip_project: "Project",
    filters_chip_type: "Type",
    filters_chip_amount: "Amount",
    filter_account_placeholder: "Account",
    filter_account_all: "All accounts",
    filter_account_manage: "Manage accounts",
    filter_categories: "Categories",
    filter_accounts: "Accounts",
    filter_all_short: "All",
    filter_n_selected: "{{count}} selected",
    filter_missing_info: "Missing info",
    filter_missing_info_tooltip: "Show only transactions missing information",
    filter_date_from: "From date",
    filter_date_to: "To date",
    table_operation: "Operation",
    table_date: "Date",
    table_status: "Status",
    table_category: "Category",
    table_bank: "Bank",
    table_amount: "Amount",
    loading: "Loading transactions...",
    empty_table: "No transactions found.",
    status_complete: "Complete",
    status_missing_info: "Missing info",
    status_missing_info_hint: "This transaction requires additional information or documents",
    status_document_requested: "Document requested",
    status_document_requested_hint: "A document was requested for this transaction.",
    showing_count: "Showing {{shown}} of {{total}} transactions",
    loading_more: "Loading...",
    load_previous: "Load previous transactions",
    details_sr_title: "Transaction details and information",
    details_title: "Details",
    details_date_label: "Date",
    details_description_label: "Description",
    details_status_label: "Status",
    details_status_complete: "Complete",
    details_status_missing: "Missing information",
    details_reference_label: "Reference",
    details_category_label: "Category",
    details_accounting_label: "Accounting",
    details_account_label: "Account",
    details_notes_label: "Notes",
    documents_title_missing: "Information missing",
    documents_title: "Documents",
    documents_missing_description: "Add a document to complete this transaction",
    documents_description: "Upload invoices or receipts for this transaction",
    documents_uploading: "Uploading...",
    documents_add: "Add document",
    documents_upload_progress: "Uploading {{current}}/{{total}}",
    documents_drop: "Drop file to upload",
    documents_drag: "Drag & drop files here",
    documents_failed_title: "Failed uploads",
    documents_no_required_label: "No document required",
    documents_no_required_hint: "Mark as not requiring documentation",
    documents_preview_label: "Preview documents ({{count}})",
    documents_preview_title: "Document preview",
    documents_preview_open: "Open",
    documents_preview_empty: "No documents available",
    documents_preview_hint: "Preview is read-only and does not change the transaction.",
    documents_preview_zoom_in: "Zoom in",
    documents_preview_zoom_out: "Zoom out",
    documents_preview_zoom_fit: "Fit",
    change_category: "Change category",
    select_all_label: "Select all transactions",
    select_one_label: "Select transaction",
    default_description: "Bank transaction",
    default_account: "Bank account",
    default_document_name: "Document",
    load_error: "Failed to load transactions."
  },
  "es": {
    title: "Transacciones",
    description: "Fuente de verdad para toda la actividad financiera",
    empty_state_title: "Aún no hay transacciones",
    empty_state_description: "Conecta tu cuenta bancaria vía Open Banking para importar y visualizar automáticamente todas tus transacciones aquí.",
    empty_state_button: "Conectar banco",
    vendor_label: "Proveedor",
    vendor_create: "Crear proveedor",
    vendor_update: "Cambiar proveedor",
    vendor_created: "Proveedor creado",
    vendor_create_failed: "Error al crear proveedor",
    vendor_name_required: "El nombre del proveedor es obligatorio",
    vendor_name_placeholder: "Nombre del proveedor",
    vendor_updated: "Proveedor actualizado",
    vendor_assigned: "Proveedor asignado",
    vendor_clear: "Sin proveedor",
    vendor_removed: "Proveedor desvinculado",
    vendor_remove_failed: "No se pudo desvincular el proveedor",
    vendor_select_placeholder: "Seleccionar proveedor",
    vendor_select_empty: "No hay proveedores disponibles",

    person_label: "Associated person",
    person_select_placeholder: "Select person",
    person_select_empty: "No active people",
    person_assigned: "Person associated",
    person_removed: "Person unassigned",
    person_update_failed: "Failed to update person",
    person_remove_failed: "Failed to unassign person",
    person_clear: "No person",
    person_missing_context: "Missing context",
    allocation_title: "Asignación",
    allocation_description: "Distribuye esta transacción entre personas para análisis (no cambia el movimiento bancario).",
    allocation_loading: "Cargando asignaciones...",
    allocation_empty: "Sin asignaciones.",
    allocation_add: "Asignar a personas",
    allocation_edit: "Editar asignación",
    allocation_remove: "Eliminar asignación",
    allocation_recommended: "Recomendado",
    allocation_editor_title: "Asignar a personas",
    allocation_editor_description: "Divide el importe entre personas para análisis.",
    allocation_person_placeholder: "Seleccionar persona",
    allocation_no_people: "Sin personas activas",
    allocation_amount_placeholder: "Importe",
    allocation_note_placeholder: "Nota (opcional)",
    allocation_add_row: "Añadir persona",
    allocation_add_all_people: "Añadir todas las personas",
    allocation_table_person: "Persona",
    allocation_table_amount: "Importe",
    allocation_table_note: "Nota",
    allocation_table_actions: "Acciones",
    allocation_total: "Total asignado",
    allocation_remainder: "Pendiente",
    allocation_microcopy: "Las asignaciones son solo analíticas y no modifican la transacción bancaria.",
    allocation_not_balanced_hint: "El total asignado debe coincidir con el importe de la transacción.",
    allocation_cancel: "Cancelar",
    allocation_save: "Guardar",
    allocation_required: "Añade al menos una persona.",
    allocation_invalid_rows: "Completa persona e importe en todas las filas.",
    allocation_duplicate_person: "Cada persona solo puede asignarse una vez.",
    allocation_not_balanced: "El total asignado debe ser {{amount}}.",
    allocation_saved: "Asignación guardada",
    allocation_save_failed: "Error al guardar la asignación",
    allocation_load_failed: "Error al cargar asignaciones",
    allocation_removed: "Asignación eliminada",
    allocation_remove_failed: "Error al eliminar la asignación",
    allocation_remove_title: "¿Eliminar asignación?",
    allocation_remove_description: "Se eliminará la asignación de esta transacción.",
    allocation_remove_confirm: "Eliminar",
    allocation_remove_cancel: "Cancelar",
    client_label: "Cliente",
    client_create: "Crear cliente",
    client_update: "Cambiar cliente",
    client_created: "Cliente creado",
    client_create_failed: "Error al crear cliente",
    client_name_required: "El nombre del cliente es obligatorio",
    client_name_placeholder: "Nombre del cliente",
    client_updated: "Cliente actualizado",
    client_assigned: "Cliente asignado",
    client_clear: "Sin cliente",
    client_removed: "Cliente desvinculado",
    client_remove_failed: "No se pudo desvincular el cliente",
    client_select_placeholder: "Seleccionar cliente",
    client_select_empty: "No hay clientes disponibles",
    project_label: "Proyecto",
    project_select_placeholder: "Seleccionar proyecto",
    project_select_empty: "No hay proyectos disponibles",
    project_select_loading: "Cargando proyectos...",
    project_select_requires_client: "Selecciona primero un cliente",
    project_assigned: "Proyecto asignado",
    project_updated: "Proyecto actualizado",
    project_update_failed: "Error al actualizar el proyecto",
    project_clear: "Sin proyecto",
    project_removed: "Proyecto desvinculado",
    project_remove_failed: "No se pudo desvincular el proyecto",
    category_create: "Crear categoría",
    category_created: "Categoría creada",
    category_create_failed: "Error al crear la categoría",
    category_name_required: "El nombre de la categoría es obligatorio",
    category_name_placeholder: "Nombre de la categoría",
    category_update_failed: "Error al actualizar la categoría",
    document_requirement_update_failed: "Error al actualizar el requisito de documento",
    document_upload_failed: "Error al subir el documento",
    document_upload_success: "Documento subido",
    document_upload_too_large: "El documento debe ser de 10MB o menos",
    document_download: "Descargar documento",
    document_download_failed: "Error al descargar el documento",
    document_delete: "Eliminar documento",
    document_delete_failed: "Error al eliminar el documento",
    document_delete_title: "¿Eliminar documento?",
    document_delete_description: "El documento \"{{name}}\" se eliminará permanentemente.",
    document_delete_confirm: "Eliminar",
    document_delete_cancel: "Cancelar",
    document_request_action: "Solicitar documentación",
    document_request_action_person: "Solicitar a {{name}} el documento referente a esta transacción",
    document_request_status: "Documentación ya solicitada",
    document_request_status_person: "Documentación ya solicitada a {{name}}",
    document_request_sent: "Solicitud enviada el {{date}}",
    document_request_missing_email: "Añade el email de la persona para solicitar la documentación.",
    document_request_email_label: "Email de la persona",
    document_request_email_placeholder: "nombre@empresa.com",
    document_request_email_save_and_send: "Guardar y solicitar",
    document_request_email_invalid: "Email inválido.",
    document_request_email_save_failed: "Error al guardar el email.",
    document_request_send_success: "Solicitud enviada.",
    document_request_send_failed: "No se pudo enviar la solicitud.",
    comments_title: "Comentarios",
    comments_loading: "Cargando comentarios...",
    comments_empty: "Aún no hay comentarios.",
    comments_placeholder: "Escribe un comentario...",
    comments_send: "Enviar",
    comments_private_label: "Privado",
    comments_private_badge: "Privado",
    comments_deleted_placeholder: "Comentario eliminado",
    comments_edited_label: "editado",
    comments_attachment_add: "Adjuntar",
    comments_attachment_too_large: "Los adjuntos deben tener hasta 10MB",
    comments_attachment_upload_failed: "Error al subir el adjunto",
    comments_attachment_delete_failed: "Error al eliminar el adjunto",
    comments_create_failed: "Error al crear el comentario",
    comments_update_failed: "Error al actualizar el comentario",
    comments_delete_failed: "Error al eliminar el comentario",
    comments_delete_confirm: "¿Eliminar este comentario?",
    comments_author_fallback: "Usuario",
    comments_uploading: "Enviando...",
    comments_load_error: "Error al cargar comentarios.",
    logo_feedback_label: "Feedback del logo",
    logo_feedback_up: "Logo correcto",
    logo_feedback_down: "Logo incorrecto",
    logo_feedback_saved: "Gracias por el feedback del logo.",
    logo_feedback_removed: "Logo eliminado para esta organización.",
    logo_feedback_failed: "No se pudo guardar el feedback del logo.",
    bulk_selected: "Seleccionadas: {{count}}",
    bulk_all_selected: "Todas las {{count}} transacciones seleccionadas",
    bulk_select_all: "Seleccionar todas las {{count}} transacciones",
    bulk_clear: "Limpiar selección",
    bulk_no_document: "Marcar como completa sin documento",
    bulk_no_document_title: "¿Marcar como completa sin documento?",
    bulk_no_document_description: "¿Seguro que deseas marcar {{count}} transacciones como completas sin documento?",
    bulk_no_document_confirm: "Marcar como completa",
    bulk_no_document_cancel: "Cancelar",
    bulk_actions_title: "Acciones en lote",
    bulk_vendor_confirm_title: "¿Asignar proveedor?",
    bulk_vendor_confirm_description: "¿Seguro que deseas asignar el proveedor \"{{name}}\" a {{count}} transacciones?",
    bulk_vendor_confirm_confirm: "Asignar proveedor",
    bulk_vendor_confirm_cancel: "Cancelar",
    bulk_client_confirm_title: "¿Asignar cliente?",
    bulk_client_confirm_description: "¿Seguro que deseas asignar el cliente \"{{name}}\" a {{count}} transacciones?",
    bulk_client_confirm_confirm: "Asignar cliente",
    bulk_client_confirm_cancel: "Cancelar",
    bulk_project_confirm_title: "¿Asignar proyecto?",
    bulk_project_confirm_description: "¿Seguro que deseas asignar el proyecto \"{{name}}\" a {{count}} transacciones?",
    bulk_project_confirm_confirm: "Asignar proyecto",
    bulk_project_confirm_cancel: "Cancelar",
    bulk_category_confirm_title: "¿Asignar categoría?",
    bulk_category_confirm_description: "¿Seguro que deseas asignar la categoría \"{{name}}\" a {{count}} transacciones?",
    bulk_category_confirm_confirm: "Asignar categoría",
    bulk_category_confirm_cancel: "Cancelar",
    bulk_assign_vendor: "Asignar proveedor",
    bulk_assign_client: "Asignar cliente",
    bulk_assign_project: "Asignar proyecto",
    bulk_assign_category: "Asignar categoría",
    search_placeholder: "Buscar transacciones...",
    filter_category_placeholder: "Categoría",
    filter_category_all: "Todas las categorías",
    filter_status_placeholder: "Estado",
    filter_status_all: "Todos los estados",
    filter_type_placeholder: "Tipo",
    filter_type_all: "Todos",
    filter_type_income: "Ingresos",
    filter_type_expense: "Gastos",
    filter_project_placeholder: "Proyecto",
    filter_project_all: "Todos los proyectos",
    filter_project_empty: "Sin proyectos",
    filter_amount_label: "Importe",
    filter_amount_min: "Importe mínimo",
    filter_amount_max: "Importe máximo",
    filters_advanced: "Filtros avanzados",
    filters_apply: "Aplicar",
    filters_clear_all: "Limpiar filtros",
    recover_logos: "Recuperar logos",
    recover_logos_success: "Logos recuperados: {{resolved}} ({{reused}} en caché)",
    recover_logos_failed: "Error al recuperar logos",
    reprocess_merchants: "Reprocesar comercios",
    reprocess_merchants_success: "Comercios reprocesados: {{updated}}/{{evaluated}} ({{hints}} hints)",
    reprocess_merchants_failed: "Error al reprocesar comercios",
    filters_remove_chip: "Eliminar filtro {{label}}",
    filters_chip_search: "Búsqueda",
    filters_chip_date: "Fecha",
    filters_chip_account: "Cuenta",
    filters_chip_category: "Categoría",
    filters_chip_status: "Estado",
    filters_chip_project: "Proyecto",
    filters_chip_type: "Tipo",
    filters_chip_amount: "Importe",
    filter_account_placeholder: "Cuenta",
    filter_account_all: "Todas las cuentas",
    filter_account_manage: "Gestionar cuentas",
    filter_categories: "Categorías",
    filter_accounts: "Cuentas",
    filter_all_short: "Todas",
    filter_n_selected: "{{count}} seleccionada",
    filter_missing_info: "Info faltante",
    filter_missing_info_tooltip: "Mostrar solo transacciones con información faltante",
    filter_date_from: "Desde fecha",
    filter_date_to: "Hasta fecha",
    table_operation: "Operación",
    table_date: "Fecha",
    table_status: "Estado",
    table_category: "Categoría",
    table_bank: "Banco",
    table_amount: "Importe",
    loading: "Cargando transacciones...",
    empty_table: "No se encontraron transacciones.",
    status_complete: "Completa",
    status_missing_info: "Info faltante",
    status_missing_info_hint: "Esta transacción requiere información o documentos adicionales",
    status_document_requested: "Documentación solicitada",
    status_document_requested_hint: "Se solicitó documentación para esta transacción.",
    showing_count: "Mostrando {{shown}} de {{total}} transacciones",
    loading_more: "Cargando...",
    load_previous: "Cargar transacciones anteriores",
    details_sr_title: "Detalles e información de la transacción",
    details_title: "Detalles",
    details_date_label: "Fecha",
    details_description_label: "Descripción",
    details_status_label: "Estado",
    details_status_complete: "Completa",
    details_status_missing: "Información faltante",
    details_reference_label: "Referencia",
    details_category_label: "Categoría",
    details_accounting_label: "Contabilidad",
    details_account_label: "Cuenta",
    details_notes_label: "Notas",
    documents_title_missing: "Información faltante",
    documents_title: "Documentos",
    documents_missing_description: "Añade un documento para completar esta transacción",
    documents_description: "Sube facturas o recibos para esta transacción",
    documents_uploading: "Cargando...",
    documents_add: "Añadir documento",
    documents_upload_progress: "Cargando {{current}}/{{total}}",
    documents_drop: "Suelta el archivo para subirlo",
    documents_drag: "Arrastra y suelta archivos aquí",
    documents_failed_title: "Fallos de carga",
    documents_no_required_label: "No se requiere documento",
    documents_no_required_hint: "Marcar como que no requiere documentación",
    documents_preview_label: "Vista previa de documentos ({{count}})",
    documents_preview_title: "Vista previa de documentos",
    documents_preview_open: "Abrir",
    documents_preview_empty: "No hay documentos disponibles",
    documents_preview_hint: "La vista previa es de solo lectura y no cambia la transacción.",
    documents_preview_zoom_in: "Aumentar zoom",
    documents_preview_zoom_out: "Reducir zoom",
    documents_preview_zoom_fit: "Ajustar",
    change_category: "Cambiar categoría",
    select_all_label: "Seleccionar todas las transacciones",
    select_one_label: "Seleccionar transacción",
    default_description: "Transacción bancaria",
    default_account: "Cuenta bancaria",
    default_document_name: "Documento",
    load_error: "Error al cargar transacciones."
  },
  "et": {
    title: "Tehingud",
    description: "Tõeallikas kogu finantstegevuse kohta",
    empty_state_title: "Tehinguid pole veel",
    empty_state_description: "Ühendage oma pangakonto Open Bankingu kaudu, et importida ja vaadata automaatselt kõiki oma tehinguid siin.",
    empty_state_button: "Ühenda pangakonto",
    vendor_label: "Tarnija",
    vendor_create: "Loo tarnija",
    vendor_update: "Muuda tarnijat",
    vendor_created: "Tarnija loodud",
    vendor_create_failed: "Tarnija loomine ebaõnnestus",
    vendor_name_required: "Tarnija nimi on kohustuslik",
    vendor_name_placeholder: "Tarnija nimi",
    vendor_updated: "Tarnija uuendatud",
    vendor_assigned: "Tarnija seostatud",
    vendor_clear: "Ilma tarnijata",
    vendor_removed: "Tarnija seos eemaldatud",
    vendor_remove_failed: "Tarnija seose eemaldamine ebaõnnestus",
    vendor_select_placeholder: "Vali tarnija",
    vendor_select_empty: "Tarnijaid pole saadaval",

    person_label: "Associated person",
    person_select_placeholder: "Select person",
    person_select_empty: "No active people",
    person_assigned: "Person associated",
    person_removed: "Person unassigned",
    person_update_failed: "Failed to update person",
    person_remove_failed: "Failed to unassign person",
    person_clear: "No person",
    person_missing_context: "Missing context",
    allocation_title: "Allocation",
    allocation_description: "Distribute this transaction across people for analytics (does not change the bank movement).",
    allocation_loading: "Loading allocations...",
    allocation_empty: "No allocations yet.",
    allocation_add: "Allocate to people",
    allocation_edit: "Edit allocation",
    allocation_remove: "Remove allocation",
    allocation_recommended: "Recommended",
    allocation_editor_title: "Allocate to people",
    allocation_editor_description: "Split the amount across people for analytics.",
    allocation_person_placeholder: "Select person",
    allocation_no_people: "No active people",
    allocation_amount_placeholder: "Amount",
    allocation_note_placeholder: "Note (optional)",
    allocation_add_row: "Add person",
    allocation_add_all_people: "Lisa kõik inimesed",
    allocation_table_person: "Isik",
    allocation_table_amount: "Summa",
    allocation_table_note: "Märkus",
    allocation_table_actions: "Toimingud",
    allocation_total: "Allocated total",
    allocation_remainder: "Remaining",
    allocation_microcopy: "Allocations are analytics-only and do not change the bank transaction.",
    allocation_not_balanced_hint: "Allocated total must match the transaction amount.",
    allocation_cancel: "Cancel",
    allocation_save: "Save",
    allocation_required: "Add at least one person.",
    allocation_invalid_rows: "Fill in person and amount for every row.",
    allocation_duplicate_person: "Each person can only be allocated once.",
    allocation_not_balanced: "Allocated total must be {{amount}}.",
    allocation_saved: "Allocation saved",
    allocation_save_failed: "Failed to save allocation",
    allocation_load_failed: "Failed to load allocations",
    allocation_removed: "Allocation removed",
    allocation_remove_failed: "Failed to remove allocation",
    allocation_remove_title: "Remove allocation?",
    allocation_remove_description: "This transaction allocation will be removed.",
    allocation_remove_confirm: "Remove",
    allocation_remove_cancel: "Cancel",
    client_label: "Klient",
    client_create: "Loo klient",
    client_update: "Muuda klienti",
    client_created: "Klient loodud",
    client_create_failed: "Kliendi loomine ebaõnnestus",
    client_name_required: "Kliendi nimi on kohustuslik",
    client_name_placeholder: "Kliendi nimi",
    client_updated: "Klient uuendatud",
    client_assigned: "Klient seostatud",
    client_clear: "Ilma kliendita",
    client_removed: "Kliendi seos eemaldatud",
    client_remove_failed: "Kliendi seose eemaldamine ebaõnnestus",
    client_select_placeholder: "Vali klient",
    client_select_empty: "Kliente pole saadaval",
    project_label: "Projekt",
    project_select_placeholder: "Vali projekt",
    project_select_empty: "Projekte pole saadaval",
    project_select_loading: "Laen projekte...",
    project_select_requires_client: "Vali esmalt klient",
    project_assigned: "Projekt seostatud",
    project_updated: "Projekt uuendatud",
    project_update_failed: "Projekti uuendamine ebaõnnestus",
    project_clear: "Ilma projektita",
    project_removed: "Projekti seos eemaldatud",
    project_remove_failed: "Projekti seose eemaldamine ebaõnnestus",
    category_create: "Loo kategooria",
    category_created: "Kategooria loodud",
    category_create_failed: "Kategooria loomine ebaõnnestus",
    category_name_required: "Kategooria nimi on kohustuslik",
    category_name_placeholder: "Kategooria nimi",
    category_update_failed: "Kategooria uuendamine ebaõnnestus",
    document_requirement_update_failed: "Dokumendinõude uuendamine ebaõnnestus",
    document_upload_failed: "Dokumendi üleslaadimine ebaõnnestus",
    document_upload_success: "Dokument üles laaditud",
    document_upload_too_large: "Dokument peab olema kuni 10MB",
    document_download: "Laadi dokument alla",
    document_download_failed: "Dokumendi allalaadimine ebaõnnestus",
    document_delete: "Kustuta dokument",
    document_delete_failed: "Dokumendi kustutamine ebaõnnestus",
    document_delete_title: "Kustuta dokument?",
    document_delete_description: "Dokument \"{{name}}\" kustutatakse jäädavalt.",
    document_delete_confirm: "Kustuta",
    document_delete_cancel: "Tühista",
    document_request_action: "Küsi dokumenti",
    document_request_action_person: "Küsi dokumenti isikult {{name}} selle tehingu jaoks",
    document_request_status: "Dokument on juba taotletud",
    document_request_status_person: "Dokument on juba taotletud isikult {{name}}",
    document_request_sent: "Taotlus saadetud {{date}}",
    document_request_missing_email: "Lisa isiku e-post, et dokumenti küsida.",
    document_request_email_label: "Isiku e-post",
    document_request_email_placeholder: "nimi@ettevote.ee",
    document_request_email_save_and_send: "Salvesta ja küsi",
    document_request_email_invalid: "Vigane e-post.",
    document_request_email_save_failed: "E-posti salvestamine ebaõnnestus.",
    document_request_send_success: "Dokumendi taotlus saadetud.",
    document_request_send_failed: "Dokumendi taotluse saatmine ebaõnnestus.",
    comments_title: "Kommentaarid",
    comments_loading: "Laadin kommentaare...",
    comments_empty: "Kommentaare pole veel.",
    comments_placeholder: "Kirjuta kommentaar...",
    comments_send: "Saada",
    comments_private_label: "Privaatne",
    comments_private_badge: "Privaatne",
    comments_deleted_placeholder: "Kommentaar eemaldatud",
    comments_edited_label: "muudetud",
    comments_attachment_add: "Lisa fail",
    comments_attachment_too_large: "Manused peavad olema kuni 10 MB",
    comments_attachment_upload_failed: "Manuse üleslaadimine ebaõnnestus",
    comments_attachment_delete_failed: "Manuse kustutamine ebaõnnestus",
    comments_create_failed: "Kommentaari loomine ebaõnnestus",
    comments_update_failed: "Kommentaari uuendamine ebaõnnestus",
    comments_delete_failed: "Kommentaari kustutamine ebaõnnestus",
    comments_delete_confirm: "Kas kustutada see kommentaar?",
    comments_author_fallback: "Kasutaja",
    comments_uploading: "Saadan...",
    comments_load_error: "Kommentaaride laadimine ebaõnnestus.",
    logo_feedback_label: "Logo tagasiside",
    logo_feedback_up: "Logo on õige",
    logo_feedback_down: "Logo on vale",
    logo_feedback_saved: "Aitäh logo tagasiside eest.",
    logo_feedback_removed: "Logo eemaldatud selle organisatsiooni jaoks.",
    logo_feedback_failed: "Logo tagasisidet ei õnnestunud salvestada.",
    bulk_selected: "Valitud: {{count}}",
    bulk_all_selected: "Kõik {{count}} tehingut valitud",
    bulk_select_all: "Vali kõik {{count}} tehingut",
    bulk_clear: "Tühjenda valik",
    bulk_no_document: "Märgi täielikuks ilma dokumendita",
    bulk_no_document_title: "Märgistada täielikuks ilma dokumendita?",
    bulk_no_document_description: "Kas soovid märkida {{count}} tehingut täielikuks ilma dokumendita?",
    bulk_no_document_confirm: "Märgi täielikuks",
    bulk_no_document_cancel: "Tühista",
    bulk_actions_title: "Hulga toimingud",
    bulk_vendor_confirm_title: "Määra tarnija?",
    bulk_vendor_confirm_description: "Kas soovid määrata tarnija \"{{name}}\" {{count}} tehingule?",
    bulk_vendor_confirm_confirm: "Määra tarnija",
    bulk_vendor_confirm_cancel: "Tühista",
    bulk_client_confirm_title: "Määra klient?",
    bulk_client_confirm_description: "Kas soovid määrata kliendi \"{{name}}\" {{count}} tehingule?",
    bulk_client_confirm_confirm: "Määra klient",
    bulk_client_confirm_cancel: "Tühista",
    bulk_project_confirm_title: "Määra projekt?",
    bulk_project_confirm_description: "Kas soovid määrata projekti \"{{name}}\" {{count}} tehingule?",
    bulk_project_confirm_confirm: "Määra projekt",
    bulk_project_confirm_cancel: "Tühista",
    bulk_category_confirm_title: "Määra kategooria?",
    bulk_category_confirm_description: "Kas soovid määrata kategooria \"{{name}}\" {{count}} tehingule?",
    bulk_category_confirm_confirm: "Määra kategooria",
    bulk_category_confirm_cancel: "Tühista",
    bulk_assign_vendor: "Määra tarnija",
    bulk_assign_client: "Määra klient",
    bulk_assign_project: "Määra projekt",
    bulk_assign_category: "Määra kategooria",
    search_placeholder: "Otsi tehinguid...",
    filter_category_placeholder: "Kategooria",
    filter_category_all: "Kõik kategooriad",
    filter_status_placeholder: "Olek",
    filter_status_all: "Kõik olekud",
    filter_type_placeholder: "Tüüp",
    filter_type_all: "Kõik",
    filter_type_income: "Sissetulekud",
    filter_type_expense: "Kulud",
    filter_project_placeholder: "Projekt",
    filter_project_all: "Kõik projektid",
    filter_project_empty: "Projekte pole",
    filter_amount_label: "Summa",
    filter_amount_min: "Min summa",
    filter_amount_max: "Max summa",
    filters_advanced: "Täpsemad filtrid",
    filters_apply: "Rakenda",
    filters_clear_all: "Tühjenda filtrid",
    recover_logos: "Taasta logod",
    recover_logos_success: "Logod taastatud: {{resolved}} ({{reused}} vahemälus)",
    recover_logos_failed: "Logode taastamine ebaõnnestus",
    reprocess_merchants: "Töötle kaupmehed uuesti",
    reprocess_merchants_success: "Kaupmehed uuesti töödeldud: {{updated}}/{{evaluated}} ({{hints}} vihjet)",
    reprocess_merchants_failed: "Kaupmeeste uuestitöötlemine ebaõnnestus",
    filters_remove_chip: "Eemalda filter {{label}}",
    filters_chip_search: "Otsing",
    filters_chip_date: "Kuupäev",
    filters_chip_account: "Konto",
    filters_chip_category: "Kategooria",
    filters_chip_status: "Olek",
    filters_chip_project: "Projekt",
    filters_chip_type: "Tüüp",
    filters_chip_amount: "Summa",
    filter_account_placeholder: "Konto",
    filter_account_all: "Kõik kontod",
    filter_account_manage: "Halda kontosid",
    filter_categories: "Kategooriad",
    filter_accounts: "Kontod",
    filter_all_short: "Kõik",
    filter_n_selected: "{{count}} valitud",
    filter_missing_info: "Puuduv info",
    filter_missing_info_tooltip: "Kuva ainult puuduva teabega tehingud",
    filter_date_from: "Alguskuupäev",
    filter_date_to: "Lõppkuupäev",
    table_operation: "Tehing",
    table_date: "Kuupäev",
    table_status: "Olek",
    table_category: "Kategooria",
    table_bank: "Pank",
    table_amount: "Summa",
    loading: "Laen tehinguid...",
    empty_table: "Tehinguid ei leitud.",
    status_complete: "Lõpetatud",
    status_missing_info: "Info puudub",
    status_missing_info_hint: "See tehing vajab lisainfot või dokumente",
    status_document_requested: "Dokument taotletud",
    status_document_requested_hint: "Selle tehingu jaoks on dokumenti taotletud.",
    showing_count: "Kuvatakse {{shown}}/{{total}} tehingut",
    loading_more: "Laadimine...",
    load_previous: "Laadi varasemad tehingud",
    details_sr_title: "Tehingu detailid ja info",
    details_title: "Detailid",
    details_date_label: "Kuupäev",
    details_description_label: "Kirjeldus",
    details_status_label: "Olek",
    details_status_complete: "Lõpetatud",
    details_status_missing: "Info puudub",
    details_reference_label: "Viide",
    details_category_label: "Kategooria",
    details_accounting_label: "Raamatupidamine",
    details_account_label: "Konto",
    details_notes_label: "Märkmed",
    documents_title_missing: "Info puudub",
    documents_title: "Dokumendid",
    documents_missing_description: "Lisa dokument tehingu lõpetamiseks",
    documents_description: "Laadi üles arved või kviitungid selle tehingu jaoks",
    documents_uploading: "Laadimine...",
    documents_add: "Lisa dokument",
    documents_upload_progress: "Laadimine {{current}}/{{total}}",
    documents_drop: "Lohista fail üleslaadimiseks",
    documents_drag: "Lohista ja vabasta failid siia",
    documents_failed_title: "Üleslaadimine ebaõnnestus",
    documents_no_required_label: "Dokument pole nõutav",
    documents_no_required_hint: "Märgi, et dokumentatsiooni pole vaja",
    documents_preview_label: "Dokumentide eelvaade ({{count}})",
    documents_preview_title: "Dokumentide eelvaade",
    documents_preview_open: "Ava",
    documents_preview_empty: "Dokumente pole saadaval",
    documents_preview_hint: "Eelvaade on ainult lugemiseks ega muuda tehingut.",
    documents_preview_zoom_in: "Suurenda",
    documents_preview_zoom_out: "Vähenda",
    documents_preview_zoom_fit: "Mahuta",
    change_category: "Muuda kategooriat",
    select_all_label: "Vali kõik tehingud",
    select_one_label: "Vali tehing",
    default_description: "Pangatehing",
    default_account: "Pangakonto",
    default_document_name: "Dokument",
    load_error: "Tehingute laadimine ebaõnnestus."
  },
  "de": {
    title: "Transaktionen",
    description: "Quelle der Wahrheit für alle Finanzaktivitäten",
    empty_state_title: "Noch keine Transaktionen",
    empty_state_description: "Verbinden Sie Ihr Bankkonto über Open Banking, um alle Ihre Transaktionen hier automatisch zu importieren und anzuzeigen.",
    empty_state_button: "Bankkonto verbinden",
    vendor_label: "Lieferant",
    vendor_create: "Lieferant erstellen",
    vendor_update: "Lieferant ändern",
    vendor_created: "Lieferant erstellt",
    vendor_create_failed: "Lieferant konnte nicht erstellt werden",
    vendor_name_required: "Lieferantenname ist erforderlich",
    vendor_name_placeholder: "Lieferantenname",
    vendor_updated: "Lieferant aktualisiert",
    vendor_assigned: "Lieferant zugewiesen",
    vendor_clear: "Kein Lieferant",
    vendor_removed: "Lieferant-Zuordnung entfernt",
    vendor_remove_failed: "Lieferant-Zuordnung konnte nicht entfernt werden",
    vendor_select_placeholder: "Lieferant auswählen",
    vendor_select_empty: "Keine Lieferanten verfügbar",

    person_label: "Associated person",
    person_select_placeholder: "Select person",
    person_select_empty: "No active people",
    person_assigned: "Person associated",
    person_removed: "Person unassigned",
    person_update_failed: "Failed to update person",
    person_remove_failed: "Failed to unassign person",
    person_clear: "No person",
    person_missing_context: "Missing context",
    allocation_title: "Aufteilung",
    allocation_description: "Diese Transaktion auf Personen verteilen (nur Analyse, keine Änderung der Bankbewegung).",
    allocation_loading: "Aufteilungen werden geladen...",
    allocation_empty: "Keine Aufteilungen.",
    allocation_add: "Auf Personen verteilen",
    allocation_edit: "Aufteilung bearbeiten",
    allocation_remove: "Aufteilung entfernen",
    allocation_recommended: "Empfohlen",
    allocation_editor_title: "Auf Personen verteilen",
    allocation_editor_description: "Betrag zur Analyse auf Personen aufteilen.",
    allocation_person_placeholder: "Person auswählen",
    allocation_no_people: "Keine aktiven Personen",
    allocation_amount_placeholder: "Betrag",
    allocation_note_placeholder: "Notiz (optional)",
    allocation_add_row: "Person hinzufügen",
    allocation_add_all_people: "Alle Personen hinzufügen",
    allocation_table_person: "Person",
    allocation_table_amount: "Betrag",
    allocation_table_note: "Notiz",
    allocation_table_actions: "Aktionen",
    allocation_total: "Zugeteilter Gesamtbetrag",
    allocation_remainder: "Restbetrag",
    allocation_microcopy: "Aufteilungen sind nur analytisch und ändern die Banktransaktion nicht.",
    allocation_not_balanced_hint: "Der zugeteilte Gesamtbetrag muss dem Transaktionsbetrag entsprechen.",
    allocation_cancel: "Abbrechen",
    allocation_save: "Speichern",
    allocation_required: "Fügen Sie mindestens eine Person hinzu.",
    allocation_invalid_rows: "Person und Betrag in jeder Zeile ausfüllen.",
    allocation_duplicate_person: "Jede Person kann nur einmal zugeteilt werden.",
    allocation_not_balanced: "Der zugeteilte Gesamtbetrag muss {{amount}} sein.",
    allocation_saved: "Aufteilung gespeichert",
    allocation_save_failed: "Aufteilung konnte nicht gespeichert werden",
    allocation_load_failed: "Aufteilungen konnten nicht geladen werden",
    allocation_removed: "Aufteilung entfernt",
    allocation_remove_failed: "Aufteilung konnte nicht entfernt werden",
    allocation_remove_title: "Aufteilung entfernen?",
    allocation_remove_description: "Die Aufteilung dieser Transaktion wird entfernt.",
    allocation_remove_confirm: "Entfernen",
    allocation_remove_cancel: "Abbrechen",
    client_label: "Kunde",
    client_create: "Kunde erstellen",
    client_update: "Kunde ändern",
    client_created: "Kunde erstellt",
    client_create_failed: "Kunde konnte nicht erstellt werden",
    client_name_required: "Kundenname ist erforderlich",
    client_name_placeholder: "Kundenname",
    client_updated: "Kunde aktualisiert",
    client_assigned: "Kunde zugewiesen",
    client_clear: "Kein Kunde",
    client_removed: "Kunden-Zuordnung entfernt",
    client_remove_failed: "Kunden-Zuordnung konnte nicht entfernt werden",
    client_select_placeholder: "Kunde auswählen",
    client_select_empty: "Keine Kunden verfügbar",
    project_label: "Projekt",
    project_select_placeholder: "Projekt auswählen",
    project_select_empty: "Keine Projekte verfügbar",
    project_select_loading: "Projekte werden geladen...",
    project_select_requires_client: "Bitte zuerst einen Kunden auswählen",
    project_assigned: "Projekt zugewiesen",
    project_updated: "Projekt aktualisiert",
    project_update_failed: "Projektaktualisierung fehlgeschlagen",
    project_clear: "Kein Projekt",
    project_removed: "Projekt-Zuordnung entfernt",
    project_remove_failed: "Projekt-Zuordnung konnte nicht entfernt werden",
    category_create: "Kategorie erstellen",
    category_created: "Kategorie erstellt",
    category_create_failed: "Kategorie konnte nicht erstellt werden",
    category_name_required: "Kategoriename ist erforderlich",
    category_name_placeholder: "Kategoriename",
    category_update_failed: "Kategorie konnte nicht aktualisiert werden",
    document_requirement_update_failed: "Dokumentanforderung konnte nicht aktualisiert werden",
    document_upload_failed: "Dokument konnte nicht hochgeladen werden",
    document_upload_success: "Dokument hochgeladen",
    document_upload_too_large: "Dokument muss 10MB oder kleiner sein",
    document_download: "Dokument herunterladen",
    document_download_failed: "Dokument konnte nicht heruntergeladen werden",
    document_delete: "Dokument löschen",
    document_delete_failed: "Dokument konnte nicht gelöscht werden",
    document_delete_title: "Dokument löschen?",
    document_delete_description: "Das Dokument \"{{name}}\" wird dauerhaft gelöscht.",
    document_delete_confirm: "Löschen",
    document_delete_cancel: "Abbrechen",
    document_request_action: "Dokument anfordern",
    document_request_action_person: "Dokument von {{name}} für diese Transaktion anfordern",
    document_request_status: "Dokument bereits angefordert",
    document_request_status_person: "Dokument bereits bei {{name}} angefordert",
    document_request_sent: "Anfrage gesendet am {{date}}",
    document_request_missing_email: "Fügen Sie die E-Mail der Person hinzu, um Dokumente anzufordern.",
    document_request_email_label: "E-Mail der Person",
    document_request_email_placeholder: "name@unternehmen.de",
    document_request_email_save_and_send: "Speichern und anfordern",
    document_request_email_invalid: "Ungültige E-Mail.",
    document_request_email_save_failed: "E-Mail konnte nicht gespeichert werden.",
    document_request_send_success: "Dokumentanfrage gesendet.",
    document_request_send_failed: "Dokumentanfrage konnte nicht gesendet werden.",
    comments_title: "Kommentare",
    comments_loading: "Kommentare werden geladen...",
    comments_empty: "Noch keine Kommentare.",
    comments_placeholder: "Schreibe einen Kommentar...",
    comments_send: "Senden",
    comments_private_label: "Privat",
    comments_private_badge: "Privat",
    comments_deleted_placeholder: "Kommentar gelöscht",
    comments_edited_label: "bearbeitet",
    comments_attachment_add: "Anhängen",
    comments_attachment_too_large: "Anhänge müssen 10 MB oder kleiner sein",
    comments_attachment_upload_failed: "Anhang konnte nicht hochgeladen werden",
    comments_attachment_delete_failed: "Anhang konnte nicht gelöscht werden",
    comments_create_failed: "Kommentar konnte nicht erstellt werden",
    comments_update_failed: "Kommentar konnte nicht aktualisiert werden",
    comments_delete_failed: "Kommentar konnte nicht gelöscht werden",
    comments_delete_confirm: "Diesen Kommentar löschen?",
    comments_author_fallback: "Benutzer",
    comments_uploading: "Wird gesendet...",
    comments_load_error: "Kommentare konnten nicht geladen werden.",
    logo_feedback_label: "Logo-Feedback",
    logo_feedback_up: "Logo ist korrekt",
    logo_feedback_down: "Logo ist falsch",
    logo_feedback_saved: "Danke für das Logo-Feedback.",
    logo_feedback_removed: "Logo für diese Organisation entfernt.",
    logo_feedback_failed: "Logo-Feedback konnte nicht gespeichert werden.",
    bulk_selected: "Ausgewählt: {{count}}",
    bulk_all_selected: "Alle {{count}} Transaktionen ausgewählt",
    bulk_select_all: "Alle {{count}} Transaktionen auswählen",
    bulk_clear: "Auswahl aufheben",
    bulk_no_document: "Als vollständig ohne Dokument markieren",
    bulk_no_document_title: "Als vollständig ohne Dokument markieren?",
    bulk_no_document_description: "Möchtest du {{count}} Transaktionen ohne Dokument als vollständig markieren?",
    bulk_no_document_confirm: "Als vollständig markieren",
    bulk_no_document_cancel: "Abbrechen",
    bulk_actions_title: "Massenaktionen",
    bulk_vendor_confirm_title: "Lieferant zuweisen?",
    bulk_vendor_confirm_description: "Möchtest du den Lieferanten \"{{name}}\" {{count}} Transaktionen zuweisen?",
    bulk_vendor_confirm_confirm: "Lieferant zuweisen",
    bulk_vendor_confirm_cancel: "Abbrechen",
    bulk_client_confirm_title: "Kunde zuweisen?",
    bulk_client_confirm_description: "Möchtest du den Kunden \"{{name}}\" {{count}} Transaktionen zuweisen?",
    bulk_client_confirm_confirm: "Kunde zuweisen",
    bulk_client_confirm_cancel: "Abbrechen",
    bulk_project_confirm_title: "Projekt zuweisen?",
    bulk_project_confirm_description: "Möchtest du das Projekt \"{{name}}\" {{count}} Transaktionen zuweisen?",
    bulk_project_confirm_confirm: "Projekt zuweisen",
    bulk_project_confirm_cancel: "Abbrechen",
    bulk_category_confirm_title: "Kategorie zuweisen?",
    bulk_category_confirm_description: "Möchtest du die Kategorie \"{{name}}\" {{count}} Transaktionen zuweisen?",
    bulk_category_confirm_confirm: "Kategorie zuweisen",
    bulk_category_confirm_cancel: "Abbrechen",
    bulk_assign_vendor: "Lieferant zuweisen",
    bulk_assign_client: "Kunde zuweisen",
    bulk_assign_project: "Projekt zuweisen",
    bulk_assign_category: "Kategorie zuweisen",
    search_placeholder: "Transaktionen suchen...",
    filter_category_placeholder: "Kategorie",
    filter_category_all: "Alle Kategorien",
    filter_status_placeholder: "Status",
    filter_status_all: "Alle Status",
    filter_type_placeholder: "Typ",
    filter_type_all: "Alle Typen",
    filter_type_income: "Einnahmen",
    filter_type_expense: "Ausgaben",
    filter_project_placeholder: "Projekt",
    filter_project_all: "Alle Projekte",
    filter_project_empty: "Keine Projekte",
    filter_amount_label: "Betrag",
    filter_amount_min: "Mindestbetrag",
    filter_amount_max: "Höchstbetrag",
    filters_advanced: "Erweiterte Filter",
    filters_apply: "Anwenden",
    filters_clear_all: "Filter zurücksetzen",
    recover_logos: "Logos abrufen",
    recover_logos_success: "Logos abgerufen: {{resolved}} ({{reused}} im Cache)",
    recover_logos_failed: "Logos konnten nicht abgerufen werden",
    reprocess_merchants: "Händler neu verarbeiten",
    reprocess_merchants_success: "Händler neu verarbeitet: {{updated}}/{{evaluated}} ({{hints}} Hinweise)",
    reprocess_merchants_failed: "Händler konnten nicht neu verarbeitet werden",
    filters_remove_chip: "Filter entfernen {{label}}",
    filters_chip_search: "Suche",
    filters_chip_date: "Datum",
    filters_chip_account: "Konto",
    filters_chip_category: "Kategorie",
    filters_chip_status: "Status",
    filters_chip_project: "Projekt",
    filters_chip_type: "Typ",
    filters_chip_amount: "Betrag",
    filter_account_placeholder: "Konto",
    filter_account_all: "Alle Konten",
    filter_account_manage: "Konten verwalten",
    filter_categories: "Kategorien",
    filter_accounts: "Konten",
    filter_all_short: "Alle",
    filter_n_selected: "{{count}} ausgewählt",
    filter_missing_info: "Fehlende Info",
    filter_missing_info_tooltip: "Nur Transaktionen mit fehlenden Informationen anzeigen",
    filter_date_from: "Von Datum",
    filter_date_to: "Bis Datum",
    table_operation: "Vorgang",
    table_date: "Datum",
    table_status: "Status",
    table_category: "Kategorie",
    table_bank: "Bank",
    table_amount: "Betrag",
    loading: "Transaktionen werden geladen...",
    empty_table: "Keine Transaktionen gefunden.",
    status_complete: "Abgeschlossen",
    status_missing_info: "Info fehlt",
    status_missing_info_hint: "Diese Transaktion benötigt zusätzliche Informationen oder Dokumente",
    status_document_requested: "Dokument angefordert",
    status_document_requested_hint: "Für diese Transaktion wurde ein Dokument angefordert.",
    showing_count: "{{shown}} von {{total}} Transaktionen",
    loading_more: "Wird geladen...",
    load_previous: "Ältere Transaktionen laden",
    details_sr_title: "Transaktionsdetails und Informationen",
    details_title: "Details",
    details_date_label: "Datum",
    details_description_label: "Beschreibung",
    details_status_label: "Status",
    details_status_complete: "Abgeschlossen",
    details_status_missing: "Information fehlt",
    details_reference_label: "Referenz",
    details_category_label: "Kategorie",
    details_accounting_label: "Buchhaltung",
    details_account_label: "Konto",
    details_notes_label: "Notizen",
    documents_title_missing: "Information fehlt",
    documents_title: "Dokumente",
    documents_missing_description: "Füge ein Dokument hinzu, um diese Transaktion abzuschließen",
    documents_description: "Lade Rechnungen oder Belege für diese Transaktion hoch",
    documents_uploading: "Wird hochgeladen...",
    documents_add: "Dokument hinzufügen",
    documents_upload_progress: "Hochladen {{current}}/{{total}}",
    documents_drop: "Datei zum Hochladen ablegen",
    documents_drag: "Dateien hierher ziehen",
    documents_failed_title: "Fehlgeschlagene Uploads",
    documents_no_required_label: "Kein Dokument erforderlich",
    documents_no_required_hint: "Als ohne Dokumentation markieren",
    documents_preview_label: "Dokumente ansehen ({{count}})",
    documents_preview_title: "Dokumenten-Vorschau",
    documents_preview_open: "Öffnen",
    documents_preview_empty: "Keine Dokumente verfügbar",
    documents_preview_hint: "Die Vorschau ist schreibgeschützt und ändert die Transaktion nicht.",
    documents_preview_zoom_in: "Vergrößern",
    documents_preview_zoom_out: "Verkleinern",
    documents_preview_zoom_fit: "Anpassen",
    change_category: "Kategorie ändern",
    select_all_label: "Alle Transaktionen auswählen",
    select_one_label: "Transaktion auswählen",
    default_description: "Banktransaktion",
    default_account: "Bankkonto",
    default_document_name: "Dokument",
    load_error: "Transaktionen konnten nicht geladen werden."
  },
  "fr": {
    title: "Transactions",
    description: "Source de vérité pour toute l'activité financière",
    empty_state_title: "Pas encore de transactions",
    empty_state_description: "Connectez votre compte bancaire via Open Banking pour importer et visualiser automatiquement toutes vos transactions ici.",
    empty_state_button: "Connecter un compte bancaire",
    vendor_label: "Fournisseur",
    vendor_create: "Créer fournisseur",
    vendor_update: "Modifier le fournisseur",
    vendor_created: "Fournisseur créé",
    vendor_create_failed: "Échec de la création du fournisseur",
    vendor_name_required: "Le nom du fournisseur est requis",
    vendor_name_placeholder: "Nom du fournisseur",
    vendor_updated: "Fournisseur mis à jour",
    vendor_assigned: "Fournisseur attribué",
    vendor_clear: "Aucun fournisseur",
    vendor_removed: "Fournisseur dissocié",
    vendor_remove_failed: "Échec de la dissociation du fournisseur",
    vendor_select_placeholder: "Sélectionner un fournisseur",
    vendor_select_empty: "Aucun fournisseur disponible",

    person_label: "Associated person",
    person_select_placeholder: "Select person",
    person_select_empty: "No active people",
    person_assigned: "Person associated",
    person_removed: "Person unassigned",
    person_update_failed: "Failed to update person",
    person_remove_failed: "Failed to unassign person",
    person_clear: "No person",
    person_missing_context: "Missing context",
    allocation_title: "Répartition",
    allocation_description: "Répartissez cette transaction entre des personnes pour l’analyse (n’affecte pas le mouvement bancaire).",
    allocation_loading: "Chargement des répartitions...",
    allocation_empty: "Aucune répartition.",
    allocation_add: "Répartir entre des personnes",
    allocation_edit: "Modifier la répartition",
    allocation_remove: "Supprimer la répartition",
    allocation_recommended: "Recommandé",
    allocation_editor_title: "Répartir entre des personnes",
    allocation_editor_description: "Répartissez le montant entre des personnes pour l’analyse.",
    allocation_person_placeholder: "Sélectionner une personne",
    allocation_no_people: "Aucune personne active",
    allocation_amount_placeholder: "Montant",
    allocation_note_placeholder: "Note (optionnel)",
    allocation_add_row: "Ajouter une personne",
    allocation_add_all_people: "Ajouter toutes les personnes",
    allocation_table_person: "Personne",
    allocation_table_amount: "Montant",
    allocation_table_note: "Note",
    allocation_table_actions: "Actions",
    allocation_total: "Total réparti",
    allocation_remainder: "Reste",
    allocation_microcopy: "Les répartitions sont uniquement analytiques et ne modifient pas la transaction bancaire.",
    allocation_not_balanced_hint: "Le total réparti doit correspondre au montant de la transaction.",
    allocation_cancel: "Annuler",
    allocation_save: "Enregistrer",
    allocation_required: "Ajoutez au moins une personne.",
    allocation_invalid_rows: "Renseignez personne et montant pour chaque ligne.",
    allocation_duplicate_person: "Chaque personne ne peut être répartie qu’une seule fois.",
    allocation_not_balanced: "Le total réparti doit être {{amount}}.",
    allocation_saved: "Répartition enregistrée",
    allocation_save_failed: "Échec de l’enregistrement de la répartition",
    allocation_load_failed: "Échec du chargement des répartitions",
    allocation_removed: "Répartition supprimée",
    allocation_remove_failed: "Échec de la suppression de la répartition",
    allocation_remove_title: "Supprimer la répartition ?",
    allocation_remove_description: "La répartition de cette transaction sera supprimée.",
    allocation_remove_confirm: "Supprimer",
    allocation_remove_cancel: "Annuler",
    client_label: "Client",
    client_create: "Créer client",
    client_update: "Modifier le client",
    client_created: "Client créé",
    client_create_failed: "Échec de la création du client",
    client_name_required: "Le nom du client est requis",
    client_name_placeholder: "Nom du client",
    client_updated: "Client mis à jour",
    client_assigned: "Client attribué",
    client_clear: "Aucun client",
    client_removed: "Client dissocié",
    client_remove_failed: "Échec de la dissociation du client",
    client_select_placeholder: "Sélectionner un client",
    client_select_empty: "Aucun client disponible",
    project_label: "Projet",
    project_select_placeholder: "Sélectionner un projet",
    project_select_empty: "Aucun projet disponible",
    project_select_loading: "Chargement des projets...",
    project_select_requires_client: "Sélectionnez d'abord un client",
    project_assigned: "Projet attribué",
    project_updated: "Projet mis à jour",
    project_update_failed: "Échec de la mise à jour du projet",
    project_clear: "Aucun projet",
    project_removed: "Projet dissocié",
    project_remove_failed: "Échec de la dissociation du projet",
    category_create: "Créer une catégorie",
    category_created: "Catégorie créée",
    category_create_failed: "Échec de la création de la catégorie",
    category_name_required: "Le nom de la catégorie est requis",
    category_name_placeholder: "Nom de la catégorie",
    category_update_failed: "Échec de la mise à jour de la catégorie",
    document_requirement_update_failed: "Échec de la mise à jour de l'exigence de document",
    document_upload_failed: "Échec de l'envoi du document",
    document_upload_success: "Document téléversé",
    document_upload_too_large: "Le document doit faire 10 Mo ou moins",
    document_download: "Télécharger le document",
    document_download_failed: "Échec du téléchargement du document",
    document_delete: "Supprimer le document",
    document_delete_failed: "Échec de la suppression du document",
    document_delete_title: "Supprimer le document ?",
    document_delete_description: "Le document \"{{name}}\" sera supprimé définitivement.",
    document_delete_confirm: "Supprimer",
    document_delete_cancel: "Annuler",
    document_request_action: "Demander un document",
    document_request_action_person: "Demander à {{name}} le document pour cette transaction",
    document_request_status: "Document déjà demandé",
    document_request_status_person: "Document déjà demandé à {{name}}",
    document_request_sent: "Demande envoyée le {{date}}",
    document_request_missing_email: "Ajoutez l'email de la personne pour demander un document.",
    document_request_email_label: "Email de la personne",
    document_request_email_placeholder: "nom@entreprise.com",
    document_request_email_save_and_send: "Enregistrer et demander",
    document_request_email_invalid: "Email invalide.",
    document_request_email_save_failed: "Impossible d’enregistrer l’email.",
    document_request_send_success: "Demande envoyée.",
    document_request_send_failed: "Échec de l'envoi de la demande.",
    comments_title: "Commentaires",
    comments_loading: "Chargement des commentaires...",
    comments_empty: "Pas encore de commentaires.",
    comments_placeholder: "Écrire un commentaire...",
    comments_send: "Envoyer",
    comments_private_label: "Privé",
    comments_private_badge: "Privé",
    comments_deleted_placeholder: "Commentaire supprimé",
    comments_edited_label: "modifié",
    comments_attachment_add: "Joindre",
    comments_attachment_too_large: "Les pièces jointes doivent faire 10 Mo ou moins",
    comments_attachment_upload_failed: "Échec de l'envoi de la pièce jointe",
    comments_attachment_delete_failed: "Échec de la suppression de la pièce jointe",
    comments_create_failed: "Échec de la création du commentaire",
    comments_update_failed: "Échec de la mise à jour du commentaire",
    comments_delete_failed: "Échec de la suppression du commentaire",
    comments_delete_confirm: "Supprimer ce commentaire ?",
    comments_author_fallback: "Utilisateur",
    comments_uploading: "Envoi...",
    comments_load_error: "Échec du chargement des commentaires.",
    logo_feedback_label: "Avis sur le logo",
    logo_feedback_up: "Logo correct",
    logo_feedback_down: "Logo incorrect",
    logo_feedback_saved: "Merci pour votre avis sur le logo.",
    logo_feedback_removed: "Logo supprimé pour cette organisation.",
    logo_feedback_failed: "Impossible d'enregistrer l'avis sur le logo.",
    bulk_selected: "Sélectionnées : {{count}}",
    bulk_all_selected: "Toutes les {{count}} transactions sélectionnées",
    bulk_select_all: "Sélectionner les {{count}} transactions",
    bulk_clear: "Effacer la sélection",
    bulk_no_document: "Marquer comme complète sans document",
    bulk_no_document_title: "Marquer comme complète sans document ?",
    bulk_no_document_description: "Voulez-vous marquer {{count}} transactions comme complètes sans document ?",
    bulk_no_document_confirm: "Marquer comme complète",
    bulk_no_document_cancel: "Annuler",
    bulk_actions_title: "Actions en lot",
    bulk_vendor_confirm_title: "Attribuer un fournisseur ?",
    bulk_vendor_confirm_description: "Voulez-vous attribuer le fournisseur \"{{name}}\" à {{count}} transactions ?",
    bulk_vendor_confirm_confirm: "Attribuer un fournisseur",
    bulk_vendor_confirm_cancel: "Annuler",
    bulk_client_confirm_title: "Attribuer un client ?",
    bulk_client_confirm_description: "Voulez-vous attribuer le client \"{{name}}\" à {{count}} transactions ?",
    bulk_client_confirm_confirm: "Attribuer un client",
    bulk_client_confirm_cancel: "Annuler",
    bulk_project_confirm_title: "Attribuer un projet ?",
    bulk_project_confirm_description: "Voulez-vous attribuer le projet \"{{name}}\" à {{count}} transactions ?",
    bulk_project_confirm_confirm: "Attribuer un projet",
    bulk_project_confirm_cancel: "Annuler",
    bulk_category_confirm_title: "Attribuer une catégorie ?",
    bulk_category_confirm_description: "Voulez-vous attribuer la catégorie \"{{name}}\" à {{count}} transactions ?",
    bulk_category_confirm_confirm: "Attribuer une catégorie",
    bulk_category_confirm_cancel: "Annuler",
    bulk_assign_vendor: "Attribuer un fournisseur",
    bulk_assign_client: "Attribuer un client",
    bulk_assign_project: "Attribuer un projet",
    bulk_assign_category: "Attribuer une catégorie",
    search_placeholder: "Rechercher des transactions...",
    filter_category_placeholder: "Catégorie",
    filter_category_all: "Toutes les catégories",
    filter_status_placeholder: "Statut",
    filter_status_all: "Tous les statuts",
    filter_type_placeholder: "Type",
    filter_type_all: "Tous les types",
    filter_type_income: "Revenus",
    filter_type_expense: "Dépenses",
    filter_project_placeholder: "Projet",
    filter_project_all: "Tous les projets",
    filter_project_empty: "Aucun projet",
    filter_amount_label: "Montant",
    filter_amount_min: "Montant min.",
    filter_amount_max: "Montant max.",
    filters_advanced: "Filtres avancés",
    filters_apply: "Appliquer",
    filters_clear_all: "Effacer les filtres",
    recover_logos: "Récupérer les logos",
    recover_logos_success: "Logos récupérés : {{resolved}} ({{reused}} en cache)",
    recover_logos_failed: "Échec de la récupération des logos",
    reprocess_merchants: "Retraiter les marchands",
    reprocess_merchants_success: "Marchands retraités : {{updated}}/{{evaluated}} ({{hints}} indices)",
    reprocess_merchants_failed: "Échec du retraitement des marchands",
    filters_remove_chip: "Supprimer le filtre {{label}}",
    filters_chip_search: "Recherche",
    filters_chip_date: "Date",
    filters_chip_account: "Compte",
    filters_chip_category: "Catégorie",
    filters_chip_status: "Statut",
    filters_chip_project: "Projet",
    filters_chip_type: "Type",
    filters_chip_amount: "Montant",
    filter_account_placeholder: "Compte",
    filter_account_all: "Tous les comptes",
    filter_account_manage: "Gérer les comptes",
    filter_categories: "Catégories",
    filter_accounts: "Comptes",
    filter_all_short: "Tous",
    filter_n_selected: "{{count}} sélectionné",
    filter_missing_info: "Info manquante",
    filter_missing_info_tooltip: "Afficher uniquement les transactions avec des informations manquantes",
    filter_date_from: "Date de début",
    filter_date_to: "Date de fin",
    table_operation: "Opération",
    table_date: "Date",
    table_status: "Statut",
    table_category: "Catégorie",
    table_bank: "Banque",
    table_amount: "Montant",
    loading: "Chargement des transactions...",
    empty_table: "Aucune transaction trouvée.",
    status_complete: "Terminé",
    status_missing_info: "Info manquante",
    status_missing_info_hint: "Cette transaction nécessite des informations ou des documents supplémentaires",
    status_document_requested: "Document demandé",
    status_document_requested_hint: "Un document a été demandé pour cette transaction.",
    showing_count: "{{shown}} sur {{total}} transactions",
    loading_more: "Chargement...",
    load_previous: "Charger les transactions précédentes",
    details_sr_title: "Détails et informations de la transaction",
    details_title: "Détails",
    details_date_label: "Date",
    details_description_label: "Description",
    details_status_label: "Statut",
    details_status_complete: "Terminé",
    details_status_missing: "Information manquante",
    details_reference_label: "Référence",
    details_category_label: "Catégorie",
    details_accounting_label: "Comptabilité",
    details_account_label: "Compte",
    details_notes_label: "Notes",
    documents_title_missing: "Information manquante",
    documents_title: "Documents",
    documents_missing_description: "Ajoutez un document pour compléter cette transaction",
    documents_description: "Téléversez des factures ou des reçus pour cette transaction",
    documents_uploading: "Téléversement...",
    documents_add: "Ajouter un document",
    documents_upload_progress: "Téléversement {{current}}/{{total}}",
    documents_drop: "Déposez le fichier pour téléverser",
    documents_drag: "Glissez-déposez des fichiers ici",
    documents_failed_title: "Téléversements échoués",
    documents_no_required_label: "Aucun document requis",
    documents_no_required_hint: "Marquer comme ne nécessitant pas de documentation",
    documents_preview_label: "Aperçu des documents ({{count}})",
    documents_preview_title: "Aperçu des documents",
    documents_preview_open: "Ouvrir",
    documents_preview_empty: "Aucun document disponible",
    documents_preview_hint: "L’aperçu est en lecture seule et ne modifie pas la transaction.",
    documents_preview_zoom_in: "Zoomer",
    documents_preview_zoom_out: "Dézoomer",
    documents_preview_zoom_fit: "Ajuster",
    change_category: "Changer de catégorie",
    select_all_label: "Sélectionner toutes les transactions",
    select_one_label: "Sélectionner la transaction",
    default_description: "Transaction bancaire",
    default_account: "Compte bancaire",
    default_document_name: "Document",
    load_error: "Échec du chargement des transactions."
  },
  "it": {
    title: "Transazioni",
    description: "Fonte di verità per tutta l'attività finanziaria",
    empty_state_title: "Nessuna transazione ancora",
    empty_state_description: "Collega il tuo conto bancario tramite Open Banking per importare e visualizzare automaticamente tutte le tue transazioni qui.",
    empty_state_button: "Collega conto bancario",
    vendor_label: "Fornitore",
    vendor_create: "Crea fornitore",
    vendor_update: "Modifica fornitore",
    vendor_created: "Fornitore creato",
    vendor_create_failed: "Impossibile creare il fornitore",
    vendor_name_required: "Il nome del fornitore è obbligatorio",
    vendor_name_placeholder: "Nome fornitore",
    vendor_updated: "Fornitore aggiornato",
    vendor_assigned: "Fornitore assegnato",
    vendor_clear: "Nessun fornitore",
    vendor_removed: "Fornitore dissociato",
    vendor_remove_failed: "Impossibile dissociare il fornitore",
    vendor_select_placeholder: "Seleziona fornitore",
    vendor_select_empty: "Nessun fornitore disponibile",

    person_label: "Associated person",
    person_select_placeholder: "Select person",
    person_select_empty: "No active people",
    person_assigned: "Person associated",
    person_removed: "Person unassigned",
    person_update_failed: "Failed to update person",
    person_remove_failed: "Failed to unassign person",
    person_clear: "No person",
    person_missing_context: "Missing context",
    allocation_title: "Allocazione",
    allocation_description: "Distribuisci questa transazione tra persone per analisi (non modifica il movimento bancario).",
    allocation_loading: "Caricamento allocazioni...",
    allocation_empty: "Nessuna allocazione.",
    allocation_add: "Alloca a persone",
    allocation_edit: "Modifica allocazione",
    allocation_remove: "Rimuovi allocazione",
    allocation_recommended: "Consigliato",
    allocation_editor_title: "Alloca a persone",
    allocation_editor_description: "Distribuisci l'importo tra persone per analisi.",
    allocation_person_placeholder: "Seleziona persona",
    allocation_no_people: "Nessuna persona attiva",
    allocation_amount_placeholder: "Importo",
    allocation_note_placeholder: "Nota (opzionale)",
    allocation_add_row: "Aggiungi persona",
    allocation_add_all_people: "Aggiungi tutte le persone",
    allocation_table_person: "Persona",
    allocation_table_amount: "Importo",
    allocation_table_note: "Nota",
    allocation_table_actions: "Azioni",
    allocation_total: "Totale allocato",
    allocation_remainder: "Residuo",
    allocation_microcopy: "Le allocazioni sono solo analitiche e non modificano la transazione bancaria.",
    allocation_not_balanced_hint: "Il totale allocato deve corrispondere all'importo della transazione.",
    allocation_cancel: "Annulla",
    allocation_save: "Salva",
    allocation_required: "Aggiungi almeno una persona.",
    allocation_invalid_rows: "Compila persona e importo per ogni riga.",
    allocation_duplicate_person: "Ogni persona può essere allocata una sola volta.",
    allocation_not_balanced: "Il totale allocato deve essere {{amount}}.",
    allocation_saved: "Allocazione salvata",
    allocation_save_failed: "Impossibile salvare l'allocazione",
    allocation_load_failed: "Impossibile caricare le allocazioni",
    allocation_removed: "Allocazione rimossa",
    allocation_remove_failed: "Impossibile rimuovere l'allocazione",
    allocation_remove_title: "Rimuovere l'allocazione?",
    allocation_remove_description: "L'allocazione di questa transazione verrà rimossa.",
    allocation_remove_confirm: "Rimuovi",
    allocation_remove_cancel: "Annulla",
    client_label: "Cliente",
    client_create: "Crea cliente",
    client_update: "Modifica cliente",
    client_created: "Cliente creato",
    client_create_failed: "Impossibile creare il cliente",
    client_name_required: "Il nome del cliente è obbligatorio",
    client_name_placeholder: "Nome cliente",
    client_updated: "Cliente aggiornato",
    client_assigned: "Cliente assegnato",
    client_clear: "Nessun cliente",
    client_removed: "Cliente dissociato",
    client_remove_failed: "Impossibile dissociare il cliente",
    client_select_placeholder: "Seleziona cliente",
    client_select_empty: "Nessun cliente disponibile",
    project_label: "Progetto",
    project_select_placeholder: "Seleziona progetto",
    project_select_empty: "Nessun progetto disponibile",
    project_select_loading: "Caricamento progetti...",
    project_select_requires_client: "Seleziona prima un cliente",
    project_assigned: "Progetto assegnato",
    project_updated: "Progetto aggiornato",
    project_update_failed: "Impossibile aggiornare il progetto",
    project_clear: "Nessun progetto",
    project_removed: "Progetto dissociato",
    project_remove_failed: "Impossibile dissociare il progetto",
    category_create: "Crea categoria",
    category_created: "Categoria creata",
    category_create_failed: "Impossibile creare la categoria",
    category_name_required: "Il nome della categoria è obbligatorio",
    category_name_placeholder: "Nome categoria",
    category_update_failed: "Impossibile aggiornare la categoria",
    document_requirement_update_failed: "Impossibile aggiornare il requisito del documento",
    document_upload_failed: "Impossibile caricare il documento",
    document_upload_success: "Documento caricato",
    document_upload_too_large: "Il documento deve essere di 10MB o meno",
    document_download: "Scarica documento",
    document_download_failed: "Impossibile scaricare il documento",
    document_delete: "Elimina documento",
    document_delete_failed: "Impossibile eliminare il documento",
    document_delete_title: "Eliminare il documento?",
    document_delete_description: "Il documento \"{{name}}\" sarà eliminato definitivamente.",
    document_delete_confirm: "Elimina",
    document_delete_cancel: "Annulla",
    document_request_action: "Richiedi documento",
    document_request_action_person: "Richiedi a {{name}} il documento per questa transazione",
    document_request_status: "Documento già richiesto",
    document_request_status_person: "Documento già richiesto a {{name}}",
    document_request_sent: "Richiesta inviata il {{date}}",
    document_request_missing_email: "Aggiungi l'email della persona per richiedere il documento.",
    document_request_email_label: "Email della persona",
    document_request_email_placeholder: "nome@azienda.com",
    document_request_email_save_and_send: "Salva e richiedi",
    document_request_email_invalid: "Email non valida.",
    document_request_email_save_failed: "Impossibile salvare l'email.",
    document_request_send_success: "Richiesta inviata.",
    document_request_send_failed: "Impossibile inviare la richiesta.",
    comments_title: "Commenti",
    comments_loading: "Caricamento commenti...",
    comments_empty: "Nessun commento.",
    comments_placeholder: "Scrivi un commento...",
    comments_send: "Invia",
    comments_private_label: "Privato",
    comments_private_badge: "Privato",
    comments_deleted_placeholder: "Commento rimosso",
    comments_edited_label: "modificato",
    comments_attachment_add: "Allega",
    comments_attachment_too_large: "Gli allegati devono essere di 10 MB o meno",
    comments_attachment_upload_failed: "Caricamento allegato non riuscito",
    comments_attachment_delete_failed: "Eliminazione allegato non riuscita",
    comments_create_failed: "Creazione commento non riuscita",
    comments_update_failed: "Aggiornamento commento non riuscito",
    comments_delete_failed: "Eliminazione commento non riuscita",
    comments_delete_confirm: "Eliminare questo commento?",
    comments_author_fallback: "Utente",
    comments_uploading: "Invio...",
    comments_load_error: "Caricamento commenti non riuscito.",
    logo_feedback_label: "Feedback logo",
    logo_feedback_up: "Logo corretto",
    logo_feedback_down: "Logo errato",
    logo_feedback_saved: "Grazie per il feedback sul logo.",
    logo_feedback_removed: "Logo rimosso per questa organizzazione.",
    logo_feedback_failed: "Impossibile salvare il feedback sul logo.",
    bulk_selected: "Selezionate: {{count}}",
    bulk_all_selected: "Tutte le {{count}} transazioni selezionate",
    bulk_select_all: "Seleziona tutte le {{count}} transazioni",
    bulk_clear: "Cancella selezione",
    bulk_no_document: "Segna come completa senza documento",
    bulk_no_document_title: "Segnare come completa senza documento?",
    bulk_no_document_description: "Vuoi segnare {{count}} transazioni come complete senza documento?",
    bulk_no_document_confirm: "Segna come completa",
    bulk_no_document_cancel: "Annulla",
    bulk_actions_title: "Azioni di massa",
    bulk_vendor_confirm_title: "Assegnare fornitore?",
    bulk_vendor_confirm_description: "Vuoi assegnare il fornitore \"{{name}}\" a {{count}} transazioni?",
    bulk_vendor_confirm_confirm: "Assegna fornitore",
    bulk_vendor_confirm_cancel: "Annulla",
    bulk_client_confirm_title: "Assegnare cliente?",
    bulk_client_confirm_description: "Vuoi assegnare il cliente \"{{name}}\" a {{count}} transazioni?",
    bulk_client_confirm_confirm: "Assegna cliente",
    bulk_client_confirm_cancel: "Annulla",
    bulk_project_confirm_title: "Assegnare progetto?",
    bulk_project_confirm_description: "Vuoi assegnare il progetto \"{{name}}\" a {{count}} transazioni?",
    bulk_project_confirm_confirm: "Assegna progetto",
    bulk_project_confirm_cancel: "Annulla",
    bulk_category_confirm_title: "Assegnare categoria?",
    bulk_category_confirm_description: "Vuoi assegnare la categoria \"{{name}}\" a {{count}} transazioni?",
    bulk_category_confirm_confirm: "Assegna categoria",
    bulk_category_confirm_cancel: "Annulla",
    bulk_assign_vendor: "Assegna fornitore",
    bulk_assign_client: "Assegna cliente",
    bulk_assign_project: "Assegna progetto",
    bulk_assign_category: "Assegna categoria",
    search_placeholder: "Cerca transazioni...",
    filter_category_placeholder: "Categoria",
    filter_category_all: "Tutte le categorie",
    filter_status_placeholder: "Stato",
    filter_status_all: "Tutti gli stati",
    filter_type_placeholder: "Tipo",
    filter_type_all: "Tutti i tipi",
    filter_type_income: "Entrate",
    filter_type_expense: "Spese",
    filter_project_placeholder: "Progetto",
    filter_project_all: "Tutti i progetti",
    filter_project_empty: "Nessun progetto",
    filter_amount_label: "Importo",
    filter_amount_min: "Importo minimo",
    filter_amount_max: "Importo massimo",
    filters_advanced: "Filtri avanzati",
    filters_apply: "Applica",
    filters_clear_all: "Cancella filtri",
    recover_logos: "Recupera loghi",
    recover_logos_success: "Loghi recuperati: {{resolved}} ({{reused}} in cache)",
    recover_logos_failed: "Impossibile recuperare i loghi",
    reprocess_merchants: "Rielabora i commercianti",
    reprocess_merchants_success: "Commercianti rielaborati: {{updated}}/{{evaluated}} ({{hints}} hint)",
    reprocess_merchants_failed: "Impossibile rielaborare i commercianti",
    filters_remove_chip: "Rimuovi filtro {{label}}",
    filters_chip_search: "Ricerca",
    filters_chip_date: "Data",
    filters_chip_account: "Conto",
    filters_chip_category: "Categoria",
    filters_chip_status: "Stato",
    filters_chip_project: "Progetto",
    filters_chip_type: "Tipo",
    filters_chip_amount: "Importo",
    filter_account_placeholder: "Conto",
    filter_account_all: "Tutti i conti",
    filter_account_manage: "Gestisci conti",
    filter_categories: "Categorie",
    filter_accounts: "Conti",
    filter_all_short: "Tutti",
    filter_n_selected: "{{count}} selezionato",
    filter_missing_info: "Info mancante",
    filter_missing_info_tooltip: "Mostra solo transazioni con informazioni mancanti",
    filter_date_from: "Data inizio",
    filter_date_to: "Data fine",
    table_operation: "Operazione",
    table_date: "Data",
    table_status: "Stato",
    table_category: "Categoria",
    table_bank: "Banca",
    table_amount: "Importo",
    loading: "Caricamento transazioni...",
    empty_table: "Nessuna transazione trovata.",
    status_complete: "Completa",
    status_missing_info: "Info mancante",
    status_missing_info_hint: "Questa transazione richiede informazioni o documenti aggiuntivi",
    status_document_requested: "Documento richiesto",
    status_document_requested_hint: "È stato richiesto un documento per questa transazione.",
    showing_count: "Mostrando {{shown}} di {{total}} transazioni",
    loading_more: "Caricamento...",
    load_previous: "Carica transazioni precedenti",
    details_sr_title: "Dettagli e informazioni della transazione",
    details_title: "Dettagli",
    details_date_label: "Data",
    details_description_label: "Descrizione",
    details_status_label: "Stato",
    details_status_complete: "Completa",
    details_status_missing: "Informazioni mancanti",
    details_reference_label: "Riferimento",
    details_category_label: "Categoria",
    details_accounting_label: "Contabilità",
    details_account_label: "Conto",
    details_notes_label: "Note",
    documents_title_missing: "Informazioni mancanti",
    documents_title: "Documenti",
    documents_missing_description: "Aggiungi un documento per completare questa transazione",
    documents_description: "Carica fatture o ricevute per questa transazione",
    documents_uploading: "Caricamento...",
    documents_add: "Aggiungi documento",
    documents_upload_progress: "Caricamento {{current}}/{{total}}",
    documents_drop: "Rilascia il file per caricarlo",
    documents_drag: "Trascina e rilascia i file qui",
    documents_failed_title: "Caricamenti non riusciti",
    documents_no_required_label: "Documento non richiesto",
    documents_no_required_hint: "Segna come senza documentazione",
    documents_preview_label: "Anteprima documenti ({{count}})",
    documents_preview_title: "Anteprima documenti",
    documents_preview_open: "Apri",
    documents_preview_empty: "Nessun documento disponibile",
    documents_preview_hint: "L’anteprima è solo lettura e non modifica la transazione.",
    documents_preview_zoom_in: "Zoom avanti",
    documents_preview_zoom_out: "Zoom indietro",
    documents_preview_zoom_fit: "Adatta",
    change_category: "Cambia categoria",
    select_all_label: "Seleziona tutte le transazioni",
    select_one_label: "Seleziona transazione",
    default_description: "Transazione bancaria",
    default_account: "Conto bancario",
    default_document_name: "Documento",
    load_error: "Impossibile caricare le transazioni."
  },
  "nl": {
    title: "Transacties",
    description: "Bron van waarheid voor alle financiële activiteit",
    empty_state_title: "Nog geen transacties",
    empty_state_description: "Verbind uw bankrekening via Open Banking om al uw transacties hier automatisch te importeren en te bekijken.",
    empty_state_button: "Bankrekening verbinden",
    vendor_label: "Leverancier",
    vendor_create: "Leverancier maken",
    vendor_update: "Leverancier wijzigen",
    vendor_created: "Leverancier gemaakt",
    vendor_create_failed: "Leverancier maken mislukt",
    vendor_name_required: "Naam leverancier is verplicht",
    vendor_name_placeholder: "Naam leverancier",
    vendor_updated: "Leverancier bijgewerkt",
    vendor_assigned: "Leverancier gekoppeld",
    vendor_clear: "Geen leverancier",
    vendor_removed: "Leverancier losgekoppeld",
    vendor_remove_failed: "Leverancier loskoppelen mislukt",
    vendor_select_placeholder: "Selecteer leverancier",
    vendor_select_empty: "Geen leveranciers beschikbaar",

    person_label: "Associated person",
    person_select_placeholder: "Select person",
    person_select_empty: "No active people",
    person_assigned: "Person associated",
    person_removed: "Person unassigned",
    person_update_failed: "Failed to update person",
    person_remove_failed: "Failed to unassign person",
    person_clear: "No person",
    person_missing_context: "Missing context",
    allocation_title: "Allocation",
    allocation_description: "Distribute this transaction across people for analytics (does not change the bank movement).",
    allocation_loading: "Loading allocations...",
    allocation_empty: "No allocations yet.",
    allocation_add: "Allocate to people",
    allocation_edit: "Edit allocation",
    allocation_remove: "Remove allocation",
    allocation_recommended: "Recommended",
    allocation_editor_title: "Allocate to people",
    allocation_editor_description: "Split the amount across people for analytics.",
    allocation_person_placeholder: "Select person",
    allocation_no_people: "No active people",
    allocation_amount_placeholder: "Amount",
    allocation_note_placeholder: "Note (optional)",
    allocation_add_row: "Add person",
    allocation_add_all_people: "Alle personen toevoegen",
    allocation_table_person: "Persoon",
    allocation_table_amount: "Bedrag",
    allocation_table_note: "Notitie",
    allocation_table_actions: "Acties",
    allocation_total: "Allocated total",
    allocation_remainder: "Remaining",
    allocation_microcopy: "Allocations are analytics-only and do not change the bank transaction.",
    allocation_not_balanced_hint: "Allocated total must match the transaction amount.",
    allocation_cancel: "Cancel",
    allocation_save: "Save",
    allocation_required: "Add at least one person.",
    allocation_invalid_rows: "Fill in person and amount for every row.",
    allocation_duplicate_person: "Each person can only be allocated once.",
    allocation_not_balanced: "Allocated total must be {{amount}}.",
    allocation_saved: "Allocation saved",
    allocation_save_failed: "Failed to save allocation",
    allocation_load_failed: "Failed to load allocations",
    allocation_removed: "Allocation removed",
    allocation_remove_failed: "Failed to remove allocation",
    allocation_remove_title: "Remove allocation?",
    allocation_remove_description: "This transaction allocation will be removed.",
    allocation_remove_confirm: "Remove",
    allocation_remove_cancel: "Cancel",
    client_label: "Klant",
    client_create: "Klant maken",
    client_update: "Klant wijzigen",
    client_created: "Klant gemaakt",
    client_create_failed: "Klant maken mislukt",
    client_name_required: "Naam klant is verplicht",
    client_name_placeholder: "Naam klant",
    client_updated: "Klant bijgewerkt",
    client_assigned: "Klant gekoppeld",
    client_clear: "Geen klant",
    client_removed: "Klant losgekoppeld",
    client_remove_failed: "Klant loskoppelen mislukt",
    client_select_placeholder: "Selecteer klant",
    client_select_empty: "Geen klanten beschikbaar",
    project_label: "Project",
    project_select_placeholder: "Selecteer project",
    project_select_empty: "Geen projecten beschikbaar",
    project_select_loading: "Projecten laden...",
    project_select_requires_client: "Selecteer eerst een klant",
    project_assigned: "Project gekoppeld",
    project_updated: "Project bijgewerkt",
    project_update_failed: "Project bijwerken mislukt",
    project_clear: "Geen project",
    project_removed: "Project losgekoppeld",
    project_remove_failed: "Project loskoppelen mislukt",
    category_create: "Categorie maken",
    category_created: "Categorie gemaakt",
    category_create_failed: "Categorie maken mislukt",
    category_name_required: "Categorienaam is verplicht",
    category_name_placeholder: "Categorienaam",
    category_update_failed: "Categorie bijwerken mislukt",
    document_requirement_update_failed: "Documentvereiste bijwerken mislukt",
    document_upload_failed: "Document uploaden mislukt",
    document_upload_success: "Document geüpload",
    document_upload_too_large: "Document moet 10MB of kleiner zijn",
    document_download: "Document downloaden",
    document_download_failed: "Document downloaden mislukt",
    document_delete: "Document verwijderen",
    document_delete_failed: "Document verwijderen mislukt",
    document_delete_title: "Document verwijderen?",
    document_delete_description: "Het document \"{{name}}\" wordt definitief verwijderd.",
    document_delete_confirm: "Verwijderen",
    document_delete_cancel: "Annuleren",
    document_request_action: "Document aanvragen",
    document_request_action_person: "Vraag het document aan bij {{name}} voor deze transactie",
    document_request_status: "Document al aangevraagd",
    document_request_status_person: "Document al aangevraagd bij {{name}}",
    document_request_sent: "Aanvraag verzonden op {{date}}",
    document_request_missing_email: "Voeg het e-mailadres van de persoon toe om documentatie aan te vragen.",
    document_request_email_label: "E-mail van persoon",
    document_request_email_placeholder: "naam@bedrijf.nl",
    document_request_email_save_and_send: "Opslaan en aanvragen",
    document_request_email_invalid: "Ongeldig e-mailadres.",
    document_request_email_save_failed: "E-mail opslaan mislukt.",
    document_request_send_success: "Documentaanvraag verzonden.",
    document_request_send_failed: "Documentaanvraag kon niet worden verzonden.",
    comments_title: "Reacties",
    comments_loading: "Reacties laden...",
    comments_empty: "Nog geen reacties.",
    comments_placeholder: "Schrijf een reactie...",
    comments_send: "Versturen",
    comments_private_label: "Privé",
    comments_private_badge: "Privé",
    comments_deleted_placeholder: "Reactie verwijderd",
    comments_edited_label: "bewerkt",
    comments_attachment_add: "Bijvoegen",
    comments_attachment_too_large: "Bijlagen moeten 10 MB of kleiner zijn",
    comments_attachment_upload_failed: "Bijlage uploaden mislukt",
    comments_attachment_delete_failed: "Bijlage verwijderen mislukt",
    comments_create_failed: "Reactie maken mislukt",
    comments_update_failed: "Reactie bijwerken mislukt",
    comments_delete_failed: "Reactie verwijderen mislukt",
    comments_delete_confirm: "Deze reactie verwijderen?",
    comments_author_fallback: "Gebruiker",
    comments_uploading: "Versturen...",
    comments_load_error: "Reacties laden mislukt.",
    logo_feedback_label: "Logo-feedback",
    logo_feedback_up: "Logo klopt",
    logo_feedback_down: "Logo is onjuist",
    logo_feedback_saved: "Bedankt voor de logo-feedback.",
    logo_feedback_removed: "Logo verwijderd voor deze organisatie.",
    logo_feedback_failed: "Kon logo-feedback niet opslaan.",
    bulk_selected: "Geselecteerd: {{count}}",
    bulk_all_selected: "Alle {{count}} transacties geselecteerd",
    bulk_select_all: "Selecteer alle {{count}} transacties",
    bulk_clear: "Selectie wissen",
    bulk_no_document: "Markeer als compleet zonder document",
    bulk_no_document_title: "Markeren als compleet zonder document?",
    bulk_no_document_description: "Wil je {{count}} transacties als compleet zonder document markeren?",
    bulk_no_document_confirm: "Markeren als compleet",
    bulk_no_document_cancel: "Annuleren",
    bulk_actions_title: "Bulkacties",
    bulk_vendor_confirm_title: "Leverancier toewijzen?",
    bulk_vendor_confirm_description: "Wil je leverancier \"{{name}}\" toewijzen aan {{count}} transacties?",
    bulk_vendor_confirm_confirm: "Leverancier toewijzen",
    bulk_vendor_confirm_cancel: "Annuleren",
    bulk_client_confirm_title: "Klant toewijzen?",
    bulk_client_confirm_description: "Wil je klant \"{{name}}\" toewijzen aan {{count}} transacties?",
    bulk_client_confirm_confirm: "Klant toewijzen",
    bulk_client_confirm_cancel: "Annuleren",
    bulk_project_confirm_title: "Project toewijzen?",
    bulk_project_confirm_description: "Wil je project \"{{name}}\" toewijzen aan {{count}} transacties?",
    bulk_project_confirm_confirm: "Project toewijzen",
    bulk_project_confirm_cancel: "Annuleren",
    bulk_category_confirm_title: "Categorie toewijzen?",
    bulk_category_confirm_description: "Wil je categorie \"{{name}}\" toewijzen aan {{count}} transacties?",
    bulk_category_confirm_confirm: "Categorie toewijzen",
    bulk_category_confirm_cancel: "Annuleren",
    bulk_assign_vendor: "Leverancier toewijzen",
    bulk_assign_client: "Klant toewijzen",
    bulk_assign_project: "Project toewijzen",
    bulk_assign_category: "Categorie toewijzen",
    search_placeholder: "Transacties zoeken...",
    filter_category_placeholder: "Categorie",
    filter_category_all: "Alle categorieën",
    filter_status_placeholder: "Status",
    filter_status_all: "Alle statussen",
    filter_type_placeholder: "Type",
    filter_type_all: "Alle typen",
    filter_type_income: "Inkomsten",
    filter_type_expense: "Uitgaven",
    filter_project_placeholder: "Project",
    filter_project_all: "Alle projecten",
    filter_project_empty: "Geen projecten",
    filter_amount_label: "Bedrag",
    filter_amount_min: "Min. bedrag",
    filter_amount_max: "Max. bedrag",
    filters_advanced: "Geavanceerde filters",
    filters_apply: "Toepassen",
    filters_clear_all: "Filters wissen",
    recover_logos: "Logo's ophalen",
    recover_logos_success: "Logo's opgehaald: {{resolved}} ({{reused}} in cache)",
    recover_logos_failed: "Logo's ophalen mislukt",
    reprocess_merchants: "Handelaars opnieuw verwerken",
    reprocess_merchants_success: "Handelaars opnieuw verwerkt: {{updated}}/{{evaluated}} ({{hints}} hints)",
    reprocess_merchants_failed: "Handelaars opnieuw verwerken mislukt",
    filters_remove_chip: "Filter verwijderen {{label}}",
    filters_chip_search: "Zoeken",
    filters_chip_date: "Datum",
    filters_chip_account: "Rekening",
    filters_chip_category: "Categorie",
    filters_chip_status: "Status",
    filters_chip_project: "Project",
    filters_chip_type: "Type",
    filters_chip_amount: "Bedrag",
    filter_account_placeholder: "Rekening",
    filter_account_all: "Alle rekeningen",
    filter_account_manage: "Beheer rekeningen",
    filter_categories: "Categorieën",
    filter_accounts: "Rekeningen",
    filter_all_short: "Alle",
    filter_n_selected: "{{count}} geselecteerd",
    filter_missing_info: "Ontbrekende info",
    filter_missing_info_tooltip: "Toon alleen transacties met ontbrekende informatie",
    filter_date_from: "Vanaf datum",
    filter_date_to: "Tot datum",
    table_operation: "Transactie",
    table_date: "Datum",
    table_status: "Status",
    table_category: "Categorie",
    table_bank: "Bank",
    table_amount: "Bedrag",
    loading: "Transacties laden...",
    empty_table: "Geen transacties gevonden.",
    status_complete: "Voltooid",
    status_missing_info: "Info ontbreekt",
    status_missing_info_hint: "Deze transactie vereist extra informatie of documenten",
    status_document_requested: "Document aangevraagd",
    status_document_requested_hint: "Er is een document aangevraagd voor deze transactie.",
    showing_count: "{{shown}} van {{total}} transacties",
    loading_more: "Laden...",
    load_previous: "Eerdere transacties laden",
    details_sr_title: "Transactiedetails en informatie",
    details_title: "Details",
    details_date_label: "Datum",
    details_description_label: "Beschrijving",
    details_status_label: "Status",
    details_status_complete: "Voltooid",
    details_status_missing: "Informatie ontbreekt",
    details_reference_label: "Referentie",
    details_category_label: "Categorie",
    details_accounting_label: "Boekhouding",
    details_account_label: "Rekening",
    details_notes_label: "Notities",
    documents_title_missing: "Informatie ontbreekt",
    documents_title: "Documenten",
    documents_missing_description: "Voeg een document toe om deze transactie te voltooien",
    documents_description: "Upload facturen of bonnetjes voor deze transactie",
    documents_uploading: "Uploaden...",
    documents_add: "Document toevoegen",
    documents_upload_progress: "Uploaden {{current}}/{{total}}",
    documents_drop: "Laat bestand los om te uploaden",
    documents_drag: "Sleep bestanden hierheen",
    documents_failed_title: "Mislukte uploads",
    documents_no_required_label: "Geen document vereist",
    documents_no_required_hint: "Markeer als geen documentatie vereist",
    documents_preview_label: "Documenten bekijken ({{count}})",
    documents_preview_title: "Documentvoorbeeld",
    documents_preview_open: "Openen",
    documents_preview_empty: "Geen documenten beschikbaar",
    documents_preview_hint: "De voorbeeldweergave is alleen-lezen en verandert de transactie niet.",
    documents_preview_zoom_in: "Inzoomen",
    documents_preview_zoom_out: "Uitzoomen",
    documents_preview_zoom_fit: "Passend",
    change_category: "Categorie wijzigen",
    select_all_label: "Selecteer alle transacties",
    select_one_label: "Selecteer transactie",
    default_description: "Banktransactie",
    default_account: "Bankrekening",
    default_document_name: "Document",
    load_error: "Transacties laden mislukt."
  },
  "sv": {
    title: "Transaktioner",
    description: "Källa till sanning för all finansiell aktivitet",
    empty_state_title: "Inga transaktioner ännu",
    empty_state_description: "Anslut ditt bankkonto via Open Banking för att automatiskt importera och visa alla dina transaktioner här.",
    empty_state_button: "Anslut bankkonto",
    vendor_label: "Leverantör",
    vendor_create: "Skapa leverantör",
    vendor_update: "Ändra leverantör",
    vendor_created: "Leverantör skapad",
    vendor_create_failed: "Kunde inte skapa leverantör",
    vendor_name_required: "Leverantörsnamn krävs",
    vendor_name_placeholder: "Leverantörsnamn",
    vendor_updated: "Leverantör uppdaterad",
    vendor_assigned: "Leverantör kopplad",
    vendor_clear: "Ingen leverantör",
    vendor_removed: "Leverantör frånkopplad",
    vendor_remove_failed: "Kunde inte koppla från leverantör",
    vendor_select_placeholder: "Välj leverantör",
    vendor_select_empty: "Inga leverantörer tillgängliga",

    person_label: "Associated person",
    person_select_placeholder: "Select person",
    person_select_empty: "No active people",
    person_assigned: "Person associated",
    person_removed: "Person unassigned",
    person_update_failed: "Failed to update person",
    person_remove_failed: "Failed to unassign person",
    person_clear: "No person",
    person_missing_context: "Missing context",
    allocation_title: "Allocation",
    allocation_description: "Distribute this transaction across people for analytics (does not change the bank movement).",
    allocation_loading: "Loading allocations...",
    allocation_empty: "No allocations yet.",
    allocation_add: "Allocate to people",
    allocation_edit: "Edit allocation",
    allocation_remove: "Remove allocation",
    allocation_recommended: "Recommended",
    allocation_editor_title: "Allocate to people",
    allocation_editor_description: "Split the amount across people for analytics.",
    allocation_person_placeholder: "Select person",
    allocation_no_people: "No active people",
    allocation_amount_placeholder: "Amount",
    allocation_note_placeholder: "Note (optional)",
    allocation_add_row: "Add person",
    allocation_add_all_people: "Lägg till alla personer",
    allocation_table_person: "Person",
    allocation_table_amount: "Belopp",
    allocation_table_note: "Notering",
    allocation_table_actions: "Åtgärder",
    allocation_total: "Allocated total",
    allocation_remainder: "Remaining",
    allocation_microcopy: "Allocations are analytics-only and do not change the bank transaction.",
    allocation_not_balanced_hint: "Allocated total must match the transaction amount.",
    allocation_cancel: "Cancel",
    allocation_save: "Save",
    allocation_required: "Add at least one person.",
    allocation_invalid_rows: "Fill in person and amount for every row.",
    allocation_duplicate_person: "Each person can only be allocated once.",
    allocation_not_balanced: "Allocated total must be {{amount}}.",
    allocation_saved: "Allocation saved",
    allocation_save_failed: "Failed to save allocation",
    allocation_load_failed: "Failed to load allocations",
    allocation_removed: "Allocation removed",
    allocation_remove_failed: "Failed to remove allocation",
    allocation_remove_title: "Remove allocation?",
    allocation_remove_description: "This transaction allocation will be removed.",
    allocation_remove_confirm: "Remove",
    allocation_remove_cancel: "Cancel",
    client_label: "Kund",
    client_create: "Skapa kund",
    client_update: "Ändra kund",
    client_created: "Kund skapad",
    client_create_failed: "Kunde inte skapa kund",
    client_name_required: "Kundnamn krävs",
    client_name_placeholder: "Kundnamn",
    client_updated: "Kund uppdaterad",
    client_assigned: "Kund kopplad",
    client_clear: "Ingen kund",
    client_removed: "Kund frånkopplad",
    client_remove_failed: "Kunde inte koppla från kund",
    client_select_placeholder: "Välj kund",
    client_select_empty: "Inga kunder tillgängliga",
    project_label: "Projekt",
    project_select_placeholder: "Välj projekt",
    project_select_empty: "Inga projekt tillgängliga",
    project_select_loading: "Laddar projekt...",
    project_select_requires_client: "Välj först en kund",
    project_assigned: "Projekt kopplat",
    project_updated: "Projekt uppdaterat",
    project_update_failed: "Det gick inte att uppdatera projektet",
    project_clear: "Inget projekt",
    project_removed: "Projekt frånkopplat",
    project_remove_failed: "Kunde inte koppla från projekt",
    category_create: "Skapa kategori",
    category_created: "Kategori skapad",
    category_create_failed: "Kunde inte skapa kategori",
    category_name_required: "Kategorinamn krävs",
    category_name_placeholder: "Kategorinamn",
    category_update_failed: "Kunde inte uppdatera kategori",
    document_requirement_update_failed: "Kunde inte uppdatera dokumentkrav",
    document_upload_failed: "Kunde inte ladda upp dokument",
    document_upload_success: "Dokument uppladdat",
    document_upload_too_large: "Dokumentet måste vara 10 MB eller mindre",
    document_download: "Ladda ner dokument",
    document_download_failed: "Kunde inte ladda ner dokumentet",
    document_delete: "Ta bort dokument",
    document_delete_failed: "Kunde inte ta bort dokumentet",
    document_delete_title: "Ta bort dokument?",
    document_delete_description: "Dokumentet \"{{name}}\" tas bort permanent.",
    document_delete_confirm: "Ta bort",
    document_delete_cancel: "Avbryt",
    document_request_action: "Begär dokumentation",
    document_request_action_person: "Begär dokumentet från {{name}} för den här transaktionen",
    document_request_status: "Dokument redan begärt",
    document_request_status_person: "Dokument redan begärt från {{name}}",
    document_request_sent: "Begäran skickad {{date}}",
    document_request_missing_email: "Lägg till personens e-post för att begära dokumentation.",
    document_request_email_label: "Personens e-post",
    document_request_email_placeholder: "namn@foretag.se",
    document_request_email_save_and_send: "Spara och begär",
    document_request_email_invalid: "Ogiltig e-post.",
    document_request_email_save_failed: "Det gick inte att spara e-posten.",
    document_request_send_success: "Begäran skickad.",
    document_request_send_failed: "Kunde inte skicka begäran.",
    comments_title: "Kommentarer",
    comments_loading: "Laddar kommentarer...",
    comments_empty: "Inga kommentarer än.",
    comments_placeholder: "Skriv en kommentar...",
    comments_send: "Skicka",
    comments_private_label: "Privat",
    comments_private_badge: "Privat",
    comments_deleted_placeholder: "Kommentar borttagen",
    comments_edited_label: "redigerad",
    comments_attachment_add: "Bifoga",
    comments_attachment_too_large: "Bilagor måste vara 10 MB eller mindre",
    comments_attachment_upload_failed: "Det gick inte att ladda upp bilagan",
    comments_attachment_delete_failed: "Det gick inte att ta bort bilagan",
    comments_create_failed: "Det gick inte att skapa kommentaren",
    comments_update_failed: "Det gick inte att uppdatera kommentaren",
    comments_delete_failed: "Det gick inte att ta bort kommentaren",
    comments_delete_confirm: "Ta bort den här kommentaren?",
    comments_author_fallback: "Användare",
    comments_uploading: "Skickar...",
    comments_load_error: "Det gick inte att ladda kommentarer.",
    logo_feedback_label: "Logo-feedback",
    logo_feedback_up: "Loggan är korrekt",
    logo_feedback_down: "Loggan är fel",
    logo_feedback_saved: "Tack för logo-feedback.",
    logo_feedback_removed: "Loggan borttagen för den här organisationen.",
    logo_feedback_failed: "Kunde inte spara logo-feedback.",
    bulk_selected: "Valda: {{count}}",
    bulk_all_selected: "Alla {{count}} transaktioner valda",
    bulk_select_all: "Välj alla {{count}} transaktioner",
    bulk_clear: "Rensa val",
    bulk_no_document: "Markera som komplett utan dokument",
    bulk_no_document_title: "Markera som komplett utan dokument?",
    bulk_no_document_description: "Vill du markera {{count}} transaktioner som kompletta utan dokument?",
    bulk_no_document_confirm: "Markera som komplett",
    bulk_no_document_cancel: "Avbryt",
    bulk_actions_title: "Massåtgärder",
    bulk_vendor_confirm_title: "Tilldela leverantör?",
    bulk_vendor_confirm_description: "Vill du tilldela leverantören \"{{name}}\" till {{count}} transaktioner?",
    bulk_vendor_confirm_confirm: "Tilldela leverantör",
    bulk_vendor_confirm_cancel: "Avbryt",
    bulk_client_confirm_title: "Tilldela kund?",
    bulk_client_confirm_description: "Vill du tilldela kunden \"{{name}}\" till {{count}} transaktioner?",
    bulk_client_confirm_confirm: "Tilldela kund",
    bulk_client_confirm_cancel: "Avbryt",
    bulk_project_confirm_title: "Tilldela projekt?",
    bulk_project_confirm_description: "Vill du tilldela projektet \"{{name}}\" till {{count}} transaktioner?",
    bulk_project_confirm_confirm: "Tilldela projekt",
    bulk_project_confirm_cancel: "Avbryt",
    bulk_category_confirm_title: "Tilldela kategori?",
    bulk_category_confirm_description: "Vill du tilldela kategorin \"{{name}}\" till {{count}} transaktioner?",
    bulk_category_confirm_confirm: "Tilldela kategori",
    bulk_category_confirm_cancel: "Avbryt",
    bulk_assign_vendor: "Tilldela leverantör",
    bulk_assign_client: "Tilldela kund",
    bulk_assign_project: "Tilldela projekt",
    bulk_assign_category: "Tilldela kategori",
    search_placeholder: "Sök transaktioner...",
    filter_category_placeholder: "Kategori",
    filter_category_all: "Alla kategorier",
    filter_status_placeholder: "Status",
    filter_status_all: "Alla statusar",
    filter_type_placeholder: "Typ",
    filter_type_all: "Alla typer",
    filter_type_income: "Intäkter",
    filter_type_expense: "Kostnader",
    filter_project_placeholder: "Projekt",
    filter_project_all: "Alla projekt",
    filter_project_empty: "Inga projekt",
    filter_amount_label: "Belopp",
    filter_amount_min: "Min belopp",
    filter_amount_max: "Max belopp",
    filters_advanced: "Avancerade filter",
    filters_apply: "Tillämpa",
    filters_clear_all: "Rensa filter",
    recover_logos: "Hämta logotyper",
    recover_logos_success: "Logotyper hämtade: {{resolved}} ({{reused}} i cache)",
    recover_logos_failed: "Kunde inte hämta logotyper",
    reprocess_merchants: "Bearbeta handlare igen",
    reprocess_merchants_success: "Handlare ombearbetade: {{updated}}/{{evaluated}} ({{hints}} ledtrådar)",
    reprocess_merchants_failed: "Kunde inte bearbeta handlare igen",
    filters_remove_chip: "Ta bort filter {{label}}",
    filters_chip_search: "Sök",
    filters_chip_date: "Datum",
    filters_chip_account: "Konto",
    filters_chip_category: "Kategori",
    filters_chip_status: "Status",
    filters_chip_project: "Projekt",
    filters_chip_type: "Typ",
    filters_chip_amount: "Belopp",
    filter_account_placeholder: "Konto",
    filter_account_all: "Alla konton",
    filter_account_manage: "Hantera konton",
    filter_categories: "Kategorier",
    filter_accounts: "Konton",
    filter_all_short: "Alla",
    filter_n_selected: "{{count}} vald",
    filter_missing_info: "Saknad info",
    filter_missing_info_tooltip: "Visa bara transaktioner med saknad information",
    filter_date_from: "Från datum",
    filter_date_to: "Till datum",
    table_operation: "Transaktion",
    table_date: "Datum",
    table_status: "Status",
    table_category: "Kategori",
    table_bank: "Bank",
    table_amount: "Belopp",
    loading: "Laddar transaktioner...",
    empty_table: "Inga transaktioner hittades.",
    status_complete: "Slutförd",
    status_missing_info: "Info saknas",
    status_missing_info_hint: "Den här transaktionen kräver ytterligare information eller dokument",
    status_document_requested: "Dokument begärt",
    status_document_requested_hint: "Ett dokument har begärts för den här transaktionen.",
    showing_count: "Visar {{shown}} av {{total}} transaktioner",
    loading_more: "Laddar...",
    load_previous: "Ladda tidigare transaktioner",
    details_sr_title: "Transaktionsdetaljer och information",
    details_title: "Detaljer",
    details_date_label: "Datum",
    details_description_label: "Beskrivning",
    details_status_label: "Status",
    details_status_complete: "Slutförd",
    details_status_missing: "Information saknas",
    details_reference_label: "Referens",
    details_category_label: "Kategori",
    details_accounting_label: "Bokföring",
    details_account_label: "Konto",
    details_notes_label: "Anteckningar",
    documents_title_missing: "Information saknas",
    documents_title: "Dokument",
    documents_missing_description: "Lägg till ett dokument för att slutföra transaktionen",
    documents_description: "Ladda upp fakturor eller kvitton för denna transaktion",
    documents_uploading: "Laddar upp...",
    documents_add: "Lägg till dokument",
    documents_upload_progress: "Laddar upp {{current}}/{{total}}",
    documents_drop: "Släpp filen för att ladda upp",
    documents_drag: "Dra och släpp filer här",
    documents_failed_title: "Misslyckade uppladdningar",
    documents_no_required_label: "Inget dokument krävs",
    documents_no_required_hint: "Markera som att dokumentation inte krävs",
    documents_preview_label: "Förhandsgranska dokument ({{count}})",
    documents_preview_title: "Dokumentförhandsvisning",
    documents_preview_open: "Öppna",
    documents_preview_empty: "Inga dokument tillgängliga",
    documents_preview_hint: "Förhandsvisningen är skrivskyddad och ändrar inte transaktionen.",
    documents_preview_zoom_in: "Zooma in",
    documents_preview_zoom_out: "Zooma ut",
    documents_preview_zoom_fit: "Anpassa",
    change_category: "Ändra kategori",
    select_all_label: "Välj alla transaktioner",
    select_one_label: "Välj transaktion",
    default_description: "Banktransaktion",
    default_account: "Bankkonto",
    default_document_name: "Dokument",
    load_error: "Misslyckades att ladda transaktioner."
  },
  "da": {
    title: "Transaktioner",
    description: "Sandhedskilde for al finansiel aktivitet",
    empty_state_title: "Ingen transaktioner endnu",
    empty_state_description: "Forbind din bankkonto via Open Banking for automatisk at importere og se alle dine transaktioner her.",
    empty_state_button: "Forbind bankkonto",
    vendor_label: "Leverandør",
    vendor_create: "Opret leverandør",
    vendor_update: "Ændr leverandør",
    vendor_created: "Leverandør oprettet",
    vendor_create_failed: "Kunne ikke oprette leverandør",
    vendor_name_required: "Leverandørnavn er påkrævet",
    vendor_name_placeholder: "Leverandørnavn",
    vendor_updated: "Leverandør opdateret",
    vendor_assigned: "Leverandør tilknyttet",
    vendor_clear: "Ingen leverandør",
    vendor_removed: "Leverandør frakoblet",
    vendor_remove_failed: "Kunne ikke frakoble leverandør",
    vendor_select_placeholder: "Vælg leverandør",
    vendor_select_empty: "Ingen leverandører tilgængelige",

    person_label: "Associated person",
    person_select_placeholder: "Select person",
    person_select_empty: "No active people",
    person_assigned: "Person associated",
    person_removed: "Person unassigned",
    person_update_failed: "Failed to update person",
    person_remove_failed: "Failed to unassign person",
    person_clear: "No person",
    person_missing_context: "Missing context",
    allocation_title: "Allocation",
    allocation_description: "Distribute this transaction across people for analytics (does not change the bank movement).",
    allocation_loading: "Loading allocations...",
    allocation_empty: "No allocations yet.",
    allocation_add: "Allocate to people",
    allocation_edit: "Edit allocation",
    allocation_remove: "Remove allocation",
    allocation_recommended: "Recommended",
    allocation_editor_title: "Allocate to people",
    allocation_editor_description: "Split the amount across people for analytics.",
    allocation_person_placeholder: "Select person",
    allocation_no_people: "No active people",
    allocation_amount_placeholder: "Amount",
    allocation_note_placeholder: "Note (optional)",
    allocation_add_row: "Add person",
    allocation_add_all_people: "Tilføj alle personer",
    allocation_table_person: "Person",
    allocation_table_amount: "Beløb",
    allocation_table_note: "Note",
    allocation_table_actions: "Handlinger",
    allocation_total: "Allocated total",
    allocation_remainder: "Remaining",
    allocation_microcopy: "Allocations are analytics-only and do not change the bank transaction.",
    allocation_not_balanced_hint: "Allocated total must match the transaction amount.",
    allocation_cancel: "Cancel",
    allocation_save: "Save",
    allocation_required: "Add at least one person.",
    allocation_invalid_rows: "Fill in person and amount for every row.",
    allocation_duplicate_person: "Each person can only be allocated once.",
    allocation_not_balanced: "Allocated total must be {{amount}}.",
    allocation_saved: "Allocation saved",
    allocation_save_failed: "Failed to save allocation",
    allocation_load_failed: "Failed to load allocations",
    allocation_removed: "Allocation removed",
    allocation_remove_failed: "Failed to remove allocation",
    allocation_remove_title: "Remove allocation?",
    allocation_remove_description: "This transaction allocation will be removed.",
    allocation_remove_confirm: "Remove",
    allocation_remove_cancel: "Cancel",
    client_label: "Kunde",
    client_create: "Opret kunde",
    client_update: "Ændr kunde",
    client_created: "Kunde oprettet",
    client_create_failed: "Kunne ikke oprette kunde",
    client_name_required: "Kundenavn er påkrævet",
    client_name_placeholder: "Kundenavn",
    client_updated: "Kunde opdateret",
    client_assigned: "Kunde tilknyttet",
    client_clear: "Ingen kunde",
    client_removed: "Kunde frakoblet",
    client_remove_failed: "Kunne ikke frakoble kunde",
    client_select_placeholder: "Vælg kunde",
    client_select_empty: "Ingen kunder tilgængelige",
    project_label: "Projekt",
    project_select_placeholder: "Vælg projekt",
    project_select_empty: "Ingen projekter tilgængelige",
    project_select_loading: "Indlæser projekter...",
    project_select_requires_client: "Vælg først en kunde",
    project_assigned: "Projekt tilknyttet",
    project_updated: "Projekt opdateret",
    project_update_failed: "Kunne ikke opdatere projektet",
    project_clear: "Intet projekt",
    project_removed: "Projekt frakoblet",
    project_remove_failed: "Kunne ikke frakoble projekt",
    category_create: "Opret kategori",
    category_created: "Kategori oprettet",
    category_create_failed: "Kunne ikke oprette kategori",
    category_name_required: "Kategorinavn er påkrævet",
    category_name_placeholder: "Kategorinavn",
    category_update_failed: "Kunne ikke opdatere kategori",
    document_requirement_update_failed: "Kunne ikke opdatere dokumentkrav",
    document_upload_failed: "Kunne ikke uploade dokument",
    document_upload_success: "Dokument uploadet",
    document_upload_too_large: "Dokumentet skal være 10MB eller mindre",
    document_download: "Download dokument",
    document_download_failed: "Kunne ikke downloade dokumentet",
    document_delete: "Slet dokument",
    document_delete_failed: "Kunne ikke slette dokumentet",
    document_delete_title: "Slet dokument?",
    document_delete_description: "Dokumentet \"{{name}}\" slettes permanent.",
    document_delete_confirm: "Slet",
    document_delete_cancel: "Annuller",
    document_request_action: "Anmod om dokumentation",
    document_request_action_person: "Anmod om dokumentet fra {{name}} for denne transaktion",
    document_request_status: "Dokument allerede anmodet",
    document_request_status_person: "Dokument allerede anmodet fra {{name}}",
    document_request_sent: "Anmodning sendt {{date}}",
    document_request_missing_email: "Tilføj personens e-mail for at anmode om dokumentation.",
    document_request_email_label: "Personens email",
    document_request_email_placeholder: "navn@virksomhed.dk",
    document_request_email_save_and_send: "Gem og anmod",
    document_request_email_invalid: "Ugyldig email.",
    document_request_email_save_failed: "Kunne ikke gemme emailen.",
    document_request_send_success: "Anmodning sendt.",
    document_request_send_failed: "Kunne ikke sende anmodningen.",
    comments_title: "Kommentarer",
    comments_loading: "Indlæser kommentarer...",
    comments_empty: "Ingen kommentarer endnu.",
    comments_placeholder: "Skriv en kommentar...",
    comments_send: "Send",
    comments_private_label: "Privat",
    comments_private_badge: "Privat",
    comments_deleted_placeholder: "Kommentar fjernet",
    comments_edited_label: "redigeret",
    comments_attachment_add: "Vedhæft",
    comments_attachment_too_large: "Vedhæftninger skal være 10 MB eller mindre",
    comments_attachment_upload_failed: "Kunne ikke uploade vedhæftning",
    comments_attachment_delete_failed: "Kunne ikke slette vedhæftning",
    comments_create_failed: "Kunne ikke oprette kommentar",
    comments_update_failed: "Kunne ikke opdatere kommentar",
    comments_delete_failed: "Kunne ikke slette kommentar",
    comments_delete_confirm: "Slet denne kommentar?",
    comments_author_fallback: "Bruger",
    comments_uploading: "Sender...",
    comments_load_error: "Kunne ikke indlæse kommentarer.",
    logo_feedback_label: "Logo-feedback",
    logo_feedback_up: "Logo er korrekt",
    logo_feedback_down: "Logo er forkert",
    logo_feedback_saved: "Tak for feedback om logoet.",
    logo_feedback_removed: "Logo fjernet for denne organisation.",
    logo_feedback_failed: "Kunne ikke gemme logo-feedback.",
    bulk_selected: "Valgt: {{count}}",
    bulk_all_selected: "Alle {{count}} transaktioner valgt",
    bulk_select_all: "Vælg alle {{count}} transaktioner",
    bulk_clear: "Ryd valg",
    bulk_no_document: "Markér som fuldført uden dokument",
    bulk_no_document_title: "Markér som fuldført uden dokument?",
    bulk_no_document_description: "Vil du markere {{count}} transaktioner som fuldførte uden dokument?",
    bulk_no_document_confirm: "Markér som fuldført",
    bulk_no_document_cancel: "Annuller",
    bulk_actions_title: "Massehandlinger",
    bulk_vendor_confirm_title: "Tildel leverandør?",
    bulk_vendor_confirm_description: "Vil du tildele leverandøren \"{{name}}\" til {{count}} transaktioner?",
    bulk_vendor_confirm_confirm: "Tildel leverandør",
    bulk_vendor_confirm_cancel: "Annuller",
    bulk_client_confirm_title: "Tildel kunde?",
    bulk_client_confirm_description: "Vil du tildele kunden \"{{name}}\" til {{count}} transaktioner?",
    bulk_client_confirm_confirm: "Tildel kunde",
    bulk_client_confirm_cancel: "Annuller",
    bulk_project_confirm_title: "Tildel projekt?",
    bulk_project_confirm_description: "Vil du tildele projektet \"{{name}}\" til {{count}} transaktioner?",
    bulk_project_confirm_confirm: "Tildel projekt",
    bulk_project_confirm_cancel: "Annuller",
    bulk_category_confirm_title: "Tildel kategori?",
    bulk_category_confirm_description: "Vil du tildele kategorien \"{{name}}\" til {{count}} transaktioner?",
    bulk_category_confirm_confirm: "Tildel kategori",
    bulk_category_confirm_cancel: "Annuller",
    bulk_assign_vendor: "Tildel leverandør",
    bulk_assign_client: "Tildel kunde",
    bulk_assign_project: "Tildel projekt",
    bulk_assign_category: "Tildel kategori",
    search_placeholder: "Søg transaktioner...",
    filter_category_placeholder: "Kategori",
    filter_category_all: "Alle kategorier",
    filter_status_placeholder: "Status",
    filter_status_all: "Alle statusser",
    filter_type_placeholder: "Type",
    filter_type_all: "Alle typer",
    filter_type_income: "Indtægter",
    filter_type_expense: "Udgifter",
    filter_project_placeholder: "Projekt",
    filter_project_all: "Alle projekter",
    filter_project_empty: "Ingen projekter",
    filter_amount_label: "Beløb",
    filter_amount_min: "Min. beløb",
    filter_amount_max: "Maks. beløb",
    filters_advanced: "Avancerede filtre",
    filters_apply: "Anvend",
    filters_clear_all: "Ryd filtre",
    recover_logos: "Hent logoer",
    recover_logos_success: "Logoer hentet: {{resolved}} ({{reused}} i cache)",
    recover_logos_failed: "Kunne ikke hente logoer",
    reprocess_merchants: "Behandl handlende igen",
    reprocess_merchants_success: "Handlende genbehandlet: {{updated}}/{{evaluated}} ({{hints}} hints)",
    reprocess_merchants_failed: "Kunne ikke genbehandle handlende",
    filters_remove_chip: "Fjern filter {{label}}",
    filters_chip_search: "Søg",
    filters_chip_date: "Dato",
    filters_chip_account: "Konto",
    filters_chip_category: "Kategori",
    filters_chip_status: "Status",
    filters_chip_project: "Projekt",
    filters_chip_type: "Type",
    filters_chip_amount: "Beløb",
    filter_account_placeholder: "Konto",
    filter_account_all: "Alle konti",
    filter_account_manage: "Administrer konti",
    filter_categories: "Kategorier",
    filter_accounts: "Konti",
    filter_all_short: "Alle",
    filter_n_selected: "{{count}} valgt",
    filter_missing_info: "Manglende info",
    filter_missing_info_tooltip: "Vis kun transaktioner med manglende oplysninger",
    filter_date_from: "Fra dato",
    filter_date_to: "Til dato",
    table_operation: "Transaktion",
    table_date: "Dato",
    table_status: "Status",
    table_category: "Kategori",
    table_bank: "Bank",
    table_amount: "Beløb",
    loading: "Indlæser transaktioner...",
    empty_table: "Ingen transaktioner fundet.",
    status_complete: "Fuldført",
    status_missing_info: "Info mangler",
    status_missing_info_hint: "Denne transaktion kræver yderligere oplysninger eller dokumenter",
    status_document_requested: "Dokument anmodet",
    status_document_requested_hint: "Der er anmodet om et dokument for denne transaktion.",
    showing_count: "Viser {{shown}} af {{total}} transaktioner",
    loading_more: "Indlæser...",
    load_previous: "Indlæs tidligere transaktioner",
    details_sr_title: "Transaktionsdetaljer og information",
    details_title: "Detaljer",
    details_date_label: "Dato",
    details_description_label: "Beskrivelse",
    details_status_label: "Status",
    details_status_complete: "Fuldført",
    details_status_missing: "Information mangler",
    details_reference_label: "Reference",
    details_category_label: "Kategori",
    details_accounting_label: "Bogføring",
    details_account_label: "Konto",
    details_notes_label: "Noter",
    documents_title_missing: "Information mangler",
    documents_title: "Dokumenter",
    documents_missing_description: "Tilføj et dokument for at fuldføre denne transaktion",
    documents_description: "Upload fakturaer eller kvitteringer for denne transaktion",
    documents_uploading: "Uploader...",
    documents_add: "Tilføj dokument",
    documents_upload_progress: "Uploader {{current}}/{{total}}",
    documents_drop: "Slip filen for at uploade",
    documents_drag: "Træk og slip filer her",
    documents_failed_title: "Fejlede uploads",
    documents_no_required_label: "Intet dokument kræves",
    documents_no_required_hint: "Markér som ikke kræver dokumentation",
    documents_preview_label: "Forhåndsvis dokumenter ({{count}})",
    documents_preview_title: "Dokumentforhåndsvisning",
    documents_preview_open: "Åbn",
    documents_preview_empty: "Ingen dokumenter tilgængelige",
    documents_preview_hint: "Forhåndsvisningen er skrivebeskyttet og ændrer ikke transaktionen.",
    documents_preview_zoom_in: "Zoom ind",
    documents_preview_zoom_out: "Zoom ud",
    documents_preview_zoom_fit: "Tilpas",
    change_category: "Skift kategori",
    select_all_label: "Vælg alle transaktioner",
    select_one_label: "Vælg transaktion",
    default_description: "Banktransaktion",
    default_account: "Bankkonto",
    default_document_name: "Dokument",
    load_error: "Kunne ikke indlæse transaktioner."
  },
  "fi": {
    title: "Tapahtumat",
    description: "Totuuden lähde kaikesta taloudellisesta toiminnasta",
    empty_state_title: "Ei tapahtumia vielä",
    empty_state_description: "Yhdistä pankkitilisi Open Bankingin kautta tuodaksesi ja nähdäksesi automaattisesti kaikki tapahtumasi täällä.",
    empty_state_button: "Yhdistä pankkitili",
    vendor_label: "Toimittaja",
    vendor_create: "Luo toimittaja",
    vendor_update: "Muokkaa toimittajaa",
    vendor_created: "Toimittaja luotu",
    vendor_create_failed: "Toimittajan luonti epäonnistui",
    vendor_name_required: "Toimittajan nimi on pakollinen",
    vendor_name_placeholder: "Toimittajan nimi",
    vendor_updated: "Toimittaja päivitetty",
    vendor_assigned: "Toimittaja liitetty",
    vendor_clear: "Ei toimittajaa",
    vendor_removed: "Toimittajan yhteys poistettu",
    vendor_remove_failed: "Toimittajan yhteyden poistaminen epäonnistui",
    vendor_select_placeholder: "Valitse toimittaja",
    vendor_select_empty: "Ei toimittajia saatavilla",

    person_label: "Associated person",
    person_select_placeholder: "Select person",
    person_select_empty: "No active people",
    person_assigned: "Person associated",
    person_removed: "Person unassigned",
    person_update_failed: "Failed to update person",
    person_remove_failed: "Failed to unassign person",
    person_clear: "No person",
    person_missing_context: "Missing context",
    allocation_title: "Allocation",
    allocation_description: "Distribute this transaction across people for analytics (does not change the bank movement).",
    allocation_loading: "Loading allocations...",
    allocation_empty: "No allocations yet.",
    allocation_add: "Allocate to people",
    allocation_edit: "Edit allocation",
    allocation_remove: "Remove allocation",
    allocation_recommended: "Recommended",
    allocation_editor_title: "Allocate to people",
    allocation_editor_description: "Split the amount across people for analytics.",
    allocation_person_placeholder: "Select person",
    allocation_no_people: "No active people",
    allocation_amount_placeholder: "Amount",
    allocation_note_placeholder: "Note (optional)",
    allocation_add_row: "Add person",
    allocation_add_all_people: "Lisää kaikki henkilöt",
    allocation_table_person: "Henkilö",
    allocation_table_amount: "Summa",
    allocation_table_note: "Muistiinpano",
    allocation_table_actions: "Toiminnot",
    allocation_total: "Allocated total",
    allocation_remainder: "Remaining",
    allocation_microcopy: "Allocations are analytics-only and do not change the bank transaction.",
    allocation_not_balanced_hint: "Allocated total must match the transaction amount.",
    allocation_cancel: "Cancel",
    allocation_save: "Save",
    allocation_required: "Add at least one person.",
    allocation_invalid_rows: "Fill in person and amount for every row.",
    allocation_duplicate_person: "Each person can only be allocated once.",
    allocation_not_balanced: "Allocated total must be {{amount}}.",
    allocation_saved: "Allocation saved",
    allocation_save_failed: "Failed to save allocation",
    allocation_load_failed: "Failed to load allocations",
    allocation_removed: "Allocation removed",
    allocation_remove_failed: "Failed to remove allocation",
    allocation_remove_title: "Remove allocation?",
    allocation_remove_description: "This transaction allocation will be removed.",
    allocation_remove_confirm: "Remove",
    allocation_remove_cancel: "Cancel",
    client_label: "Asiakas",
    client_create: "Luo asiakas",
    client_update: "Muokkaa asiakasta",
    client_created: "Asiakas luotu",
    client_create_failed: "Asiakkaan luonti epäonnistui",
    client_name_required: "Asiakkaan nimi on pakollinen",
    client_name_placeholder: "Asiakkaan nimi",
    client_updated: "Asiakas päivitetty",
    client_assigned: "Asiakas liitetty",
    client_clear: "Ei asiakasta",
    client_removed: "Asiakkaan yhteys poistettu",
    client_remove_failed: "Asiakkaan yhteyden poistaminen epäonnistui",
    client_select_placeholder: "Valitse asiakas",
    client_select_empty: "Ei asiakkaita saatavilla",
    project_label: "Projekti",
    project_select_placeholder: "Valitse projekti",
    project_select_empty: "Ei projekteja saatavilla",
    project_select_loading: "Ladataan projekteja...",
    project_select_requires_client: "Valitse ensin asiakas",
    project_assigned: "Projekti liitetty",
    project_updated: "Projekti päivitetty",
    project_update_failed: "Projektin päivitys epäonnistui",
    project_clear: "Ei projektia",
    project_removed: "Projektin yhteys poistettu",
    project_remove_failed: "Projektin yhteyden poistaminen epäonnistui",
    category_create: "Luo kategoria",
    category_created: "Kategoria luotu",
    category_create_failed: "Kategorian luonti epäonnistui",
    category_name_required: "Kategorian nimi on pakollinen",
    category_name_placeholder: "Kategorian nimi",
    category_update_failed: "Kategorian päivitys epäonnistui",
    document_requirement_update_failed: "Asiakirjavaatimuksen päivitys epäonnistui",
    document_upload_failed: "Dokumentin lataus epäonnistui",
    document_upload_success: "Dokumentti ladattu",
    document_upload_too_large: "Dokumentin on oltava enintään 10MB",
    document_download: "Lataa dokumentti",
    document_download_failed: "Dokumentin lataus epäonnistui",
    document_delete: "Poista dokumentti",
    document_delete_failed: "Dokumentin poistaminen epäonnistui",
    document_delete_title: "Poistetaanko dokumentti?",
    document_delete_description: "Dokumentti \"{{name}}\" poistetaan pysyvästi.",
    document_delete_confirm: "Poista",
    document_delete_cancel: "Peruuta",
    document_request_action: "Pyydä dokumenttia",
    document_request_action_person: "Pyydä dokumenttia henkilöltä {{name}} tätä transaktiota varten",
    document_request_status: "Asiakirja on jo pyydetty",
    document_request_status_person: "Asiakirja on jo pyydetty henkilöltä {{name}}",
    document_request_sent: "Pyyntö lähetetty {{date}}",
    document_request_missing_email: "Lisää henkilön sähköposti, jotta voit pyytää dokumenttia.",
    document_request_email_label: "Henkilön sähköposti",
    document_request_email_placeholder: "nimi@yritys.fi",
    document_request_email_save_and_send: "Tallenna ja pyydä",
    document_request_email_invalid: "Virheellinen sähköposti.",
    document_request_email_save_failed: "Sähköpostin tallennus epäonnistui.",
    document_request_send_success: "Pyyntö lähetetty.",
    document_request_send_failed: "Pyynnön lähetys epäonnistui.",
    comments_title: "Kommentit",
    comments_loading: "Ladataan kommentteja...",
    comments_empty: "Ei kommentteja vielä.",
    comments_placeholder: "Kirjoita kommentti...",
    comments_send: "Lähetä",
    comments_private_label: "Yksityinen",
    comments_private_badge: "Yksityinen",
    comments_deleted_placeholder: "Kommentti poistettu",
    comments_edited_label: "muokattu",
    comments_attachment_add: "Liitä",
    comments_attachment_too_large: "Liitteiden on oltava enintään 10 MB",
    comments_attachment_upload_failed: "Liitteen lataus epäonnistui",
    comments_attachment_delete_failed: "Liitteen poistaminen epäonnistui",
    comments_create_failed: "Kommentin luonti epäonnistui",
    comments_update_failed: "Kommentin päivitys epäonnistui",
    comments_delete_failed: "Kommentin poistaminen epäonnistui",
    comments_delete_confirm: "Poistetaanko tämä kommentti?",
    comments_author_fallback: "Käyttäjä",
    comments_uploading: "Lähetetään...",
    comments_load_error: "Kommenttien lataus epäonnistui.",
    logo_feedback_label: "Logo-palaute",
    logo_feedback_up: "Logo on oikein",
    logo_feedback_down: "Logo on väärin",
    logo_feedback_saved: "Kiitos logopalautteesta.",
    logo_feedback_removed: "Logo poistettu tältä organisaatiolta.",
    logo_feedback_failed: "Logopalautetta ei voitu tallentaa.",
    bulk_selected: "Valittu: {{count}}",
    bulk_all_selected: "Kaikki {{count}} tapahtumat valittu",
    bulk_select_all: "Valitse kaikki {{count}} tapahtumat",
    bulk_clear: "Tyhjennä valinta",
    bulk_no_document: "Merkitse valmiiksi ilman dokumenttia",
    bulk_no_document_title: "Merkitäänkö valmiiksi ilman dokumenttia?",
    bulk_no_document_description: "Haluatko merkitä {{count}} tapahtumaa valmiiksi ilman dokumenttia?",
    bulk_no_document_confirm: "Merkitse valmiiksi",
    bulk_no_document_cancel: "Peruuta",
    bulk_actions_title: "Massatoiminnot",
    bulk_vendor_confirm_title: "Määritä toimittaja?",
    bulk_vendor_confirm_description: "Haluatko määrittää toimittajan \"{{name}}\" {{count}} tapahtumalle?",
    bulk_vendor_confirm_confirm: "Määritä toimittaja",
    bulk_vendor_confirm_cancel: "Peruuta",
    bulk_client_confirm_title: "Määritä asiakas?",
    bulk_client_confirm_description: "Haluatko määrittää asiakkaan \"{{name}}\" {{count}} tapahtumalle?",
    bulk_client_confirm_confirm: "Määritä asiakas",
    bulk_client_confirm_cancel: "Peruuta",
    bulk_project_confirm_title: "Määritä projekti?",
    bulk_project_confirm_description: "Haluatko määrittää projektin \"{{name}}\" {{count}} tapahtumalle?",
    bulk_project_confirm_confirm: "Määritä projekti",
    bulk_project_confirm_cancel: "Peruuta",
    bulk_category_confirm_title: "Määritä kategoria?",
    bulk_category_confirm_description: "Haluatko määrittää kategorian \"{{name}}\" {{count}} tapahtumalle?",
    bulk_category_confirm_confirm: "Määritä kategoria",
    bulk_category_confirm_cancel: "Peruuta",
    bulk_assign_vendor: "Määritä toimittaja",
    bulk_assign_client: "Määritä asiakas",
    bulk_assign_project: "Määritä projekti",
    bulk_assign_category: "Määritä kategoria",
    search_placeholder: "Hae tapahtumia...",
    filter_category_placeholder: "Kategoria",
    filter_category_all: "Kaikki kategoriat",
    filter_status_placeholder: "Tila",
    filter_status_all: "Kaikki tilat",
    filter_type_placeholder: "Tyyppi",
    filter_type_all: "Kaikki tyypit",
    filter_type_income: "Tulot",
    filter_type_expense: "Menot",
    filter_project_placeholder: "Projekti",
    filter_project_all: "Kaikki projektit",
    filter_project_empty: "Ei projekteja",
    filter_amount_label: "Summa",
    filter_amount_min: "Minimisumma",
    filter_amount_max: "Maksimisumma",
    filters_advanced: "Lisäsuodattimet",
    filters_apply: "Käytä",
    filters_clear_all: "Tyhjennä suodattimet",
    recover_logos: "Hae logot",
    recover_logos_success: "Logot haettu: {{resolved}} ({{reused}} välimuistissa)",
    recover_logos_failed: "Logojen haku epäonnistui",
    reprocess_merchants: "Käsittele kauppiaat uudelleen",
    reprocess_merchants_success: "Kauppiaat käsitelty uudelleen: {{updated}}/{{evaluated}} ({{hints}} vihjettä)",
    reprocess_merchants_failed: "Kauppiaiden uudelleenkäsittely epäonnistui",
    filters_remove_chip: "Poista suodatin {{label}}",
    filters_chip_search: "Haku",
    filters_chip_date: "Päivä",
    filters_chip_account: "Tili",
    filters_chip_category: "Kategoria",
    filters_chip_status: "Tila",
    filters_chip_project: "Projekti",
    filters_chip_type: "Tyyppi",
    filters_chip_amount: "Summa",
    filter_account_placeholder: "Tili",
    filter_account_all: "Kaikki tilit",
    filter_account_manage: "Hallitse tilejä",
    filter_categories: "Kategoriat",
    filter_accounts: "Tilit",
    filter_all_short: "Kaikki",
    filter_n_selected: "{{count}} valittu",
    filter_missing_info: "Puuttuva tieto",
    filter_missing_info_tooltip: "Näytä vain tapahtumat, joista puuttuu tietoja",
    filter_date_from: "Alkupäivä",
    filter_date_to: "Loppupäivä",
    table_operation: "Tapahtuma",
    table_date: "Päiväys",
    table_status: "Tila",
    table_category: "Kategoria",
    table_bank: "Pankki",
    table_amount: "Summa",
    loading: "Ladataan tapahtumia...",
    empty_table: "Tapahtumia ei löytynyt.",
    status_complete: "Valmis",
    status_missing_info: "Tietoja puuttuu",
    status_missing_info_hint: "Tämä tapahtuma vaatii lisätietoja tai dokumentteja",
    status_document_requested: "Asiakirja pyydetty",
    status_document_requested_hint: "Tälle tapahtumalle on pyydetty asiakirjaa.",
    showing_count: "Näytetään {{shown}} / {{total}} tapahtumaa",
    loading_more: "Ladataan...",
    load_previous: "Lataa aiemmat tapahtumat",
    details_sr_title: "Tapahtuman tiedot ja informaatio",
    details_title: "Tiedot",
    details_date_label: "Päivä",
    details_description_label: "Kuvaus",
    details_status_label: "Tila",
    details_status_complete: "Valmis",
    details_status_missing: "Tietoja puuttuu",
    details_reference_label: "Viite",
    details_category_label: "Kategoria",
    details_accounting_label: "Kirjanpito",
    details_account_label: "Tili",
    details_notes_label: "Muistiinpanot",
    documents_title_missing: "Tietoja puuttuu",
    documents_title: "Dokumentit",
    documents_missing_description: "Lisää dokumentti tämän tapahtuman valmiiksi saattamiseksi",
    documents_description: "Lataa laskuja tai kuitteja tätä tapahtumaa varten",
    documents_uploading: "Ladataan...",
    documents_add: "Lisää dokumentti",
    documents_upload_progress: "Ladataan {{current}}/{{total}}",
    documents_drop: "Pudota tiedosto ladattavaksi",
    documents_drag: "Vedä ja pudota tiedostot tähän",
    documents_failed_title: "Epäonnistuneet lataukset",
    documents_no_required_label: "Dokumenttia ei vaadita",
    documents_no_required_hint: "Merkitse, ettei dokumentaatiota tarvita",
    documents_preview_label: "Esikatsele dokumentit ({{count}})",
    documents_preview_title: "Dokumentin esikatselu",
    documents_preview_open: "Avaa",
    documents_preview_empty: "Ei dokumentteja saatavilla",
    documents_preview_hint: "Esikatselu on vain luku -tilassa eikä muuta tapahtumaa.",
    documents_preview_zoom_in: "Lähennä",
    documents_preview_zoom_out: "Loitonna",
    documents_preview_zoom_fit: "Sovita",
    change_category: "Vaihda kategoria",
    select_all_label: "Valitse kaikki tapahtumat",
    select_one_label: "Valitse tapahtuma",
    default_description: "Pankkitapahtuma",
    default_account: "Pankkitili",
    default_document_name: "Dokumentti",
    load_error: "Tapahtumien lataus epäonnistui."
  },
};
